webpackJsonp([1],{

/***/ "+Idm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0007.7a637ca.png";

/***/ }),

/***/ "+ife":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/B3F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone2.ec33b50.png";

/***/ }),

/***/ "/Uuf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone1.c7b9ba7.png";

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Dj8j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0IJG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/003.5c63bdb.png";

/***/ }),

/***/ "0SdS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1r8j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/004.854af58.png";

/***/ }),

/***/ "2HYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2kw+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04.46c23a7.png";

/***/ }),

/***/ "3jBm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3lpv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ltW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/005.7350845.png";

/***/ }),

/***/ "489H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4cF/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.71ce664.gif";

/***/ }),

/***/ "4o0c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62Xp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-6.19d3309.png";

/***/ }),

/***/ "6ciI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0008.df4c841.png";

/***/ }),

/***/ "78Zd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0008.df4c841.png";

/***/ }),

/***/ "9WAQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0003.cf5315c.png";

/***/ }),

/***/ "9mUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A4gA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0002.f6fe120.png";

/***/ }),

/***/ "AQy6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/001.32e844a.png";

/***/ }),

/***/ "ArfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BBju":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05.d5a342b.png";

/***/ }),

/***/ "BzEj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/003.5c63bdb.png";

/***/ }),

/***/ "Bzbw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01.3edf3bd.png";

/***/ }),

/***/ "C+Ij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CR46":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0005.c6e5515.png";

/***/ }),

/***/ "CRVH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DCNY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/02.6f7414b.png";

/***/ }),

/***/ "Dj8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FuAT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G+8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7sN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hq6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IM0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ix82":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/001.32e844a.png";

/***/ }),

/***/ "JCrt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-3.8baa16f.png";

/***/ }),

/***/ "JxW2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-5.34e4d73.png";

/***/ }),

/***/ "KKZb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L3AK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAZCAYAAAA2VdDGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVkSURBVHgB7VpLTBtHGJ712sQ8bNPUSKgXHiZSSxWFBlzlwiOVIJdCLlWkVg1ppaYVEj0EKaAiyiM9oKhCTdVDD+2t6YEDFEovNDkAoWoaqQ0Vkk3Fw0aAoWCBH9SAX9v/X+9sxotNDAiCkv2k0c7Mzv/Pznz7/fMvhhAVzwKcVFScYHBra2tlc5uejWg06lxYWCgSBEEl7QSCW15etv658e/Gyz9/K3TZHgpI2Ozs7BmiquxEIY4ovu+OWFjCUlGYlqg4UiAJi4uLVpdeM1zzoD/bE9qR792yP8RL3uevvnlvbm6uGuozaJLMl4aoOEpwKysrZatZabuIokDCvph6lFdQUHDPbref6ezsTMqJGiuPDhj6ykBRvyYjikX7axcIKGze4XBUWyyWhApTksV5vd6X9Hp9Fc/zpp2dnb8zMzMfkz2kqSIhOMj0rHspKhFYwgoLC2c4jovbd61iAovBYLgPg/KwIyMjg4RCoW90Ot0NiL1RpbGK3aBn1H6JQrBn2NTUVA34mmb3nKMTALSQmUxTolhsbW3dBOK+gmqU7K0yUZmgxsubm5uj2dnZDvICqRL3Ec+oVENfMiQLiaKyurq6uMnJSWsiosRBWu01n8/nhfAYoX2RSISDUBlHBKhQA2MvQ//bRqPRCzY3QZVRpT9qR33gVdnPtg+DVOdItB6lvfKqXFMgENAAUV8ehigEq7CxsTFrRUWFG9qCSBZmIJWVlWnJjEFxp4PB4KVwOByl3wNx8gRI40hWVtYbUp8JFnQFigf7cTwdBz4E6cppNLHkR4hB3kCs0z46l1hhbJn54/rYNvpn58c6AvvRF72/H//s81F7bMMRcmHctXQooigGXbOkueBcYGJi4hTww0GJkVVVVUWGh4cXy8vL/fAgBqWhx+N5lJub2wzVEIlJUkhPT8fwKK4F67G1CLqmpiZLY2Pjp+vr6/bS0tLvIUkJklj4FMcybgVFn9ym/qh/aT4O23Re5RipXx5H4sOvOIdkI9tJY+laOOW6FM8qz6FcC/SjP769vd3S2tp6F8h65Zb9D3JQnDPlkJ/OX/qnvr7+vZGREQ/wE3sJpfu8yWQywo3rJSUlt1lDUNRST0/Pu93d3Ta/3x+UHpzk5OQQ+DsX9UEXwEPRQ0GVRsFnAM6wMLtgvJrNZvElRnvqh/EnA/sQdB5oow3H+lLMTxL45pRzu91ugd6jPlnfyZ4J26ggsCdk91mMISK9ra3tdSg/3J57fCDCKFGN1z68Cnw4YM99RBIJJYuTNvl0c3NzcUNDwwegMCPE4MWOjo7vent7nXDPDyX8lLnQD5+fn887nU4B3ogITBghBwPd4OO2PagPHKuDYoAc4GxLS8vd/RLGEjU0NOQoKiryz8zMyAKRHwbPLSgYJ7Kg4JUHeQdB3v9BfZM8CYEqkoMrLi7W2Ww2I4TEsxgSUyWMEtV0/ZP3+/r65qGLKkpO0HhaAQUgERGYLAjS34a6HxKKAFyxjopSiUoBq6urUVBWeHR01AeZ8HhL7TvVWi1vGHUvJbVhFTUwMDAPHHiBA9zzuEyaV9hh3MawFZZKSGmgYm8AUXjBFzsEAvACYb/tRRgl6sZHH18dHBx0QpcPOEgYxXii4iiAG40veRgI80F6P/5Z3ZVdhLFE9ff3O0ks9MlnlIrjBeYEp6CYIR94a3t7e6nL9rv4W9b5+z8K8+vuqdraWivcz5HGqb+CPGMgYfgpY4ak4yIS9vX0XyJRdXV1ZeQJUU/NPNUweDzAkBiBpMMDGfYD/cLqLzVVF++4XK4V+I7FTyI10z5hoCExG4oZigmyvjSyj2859cfH4wX9FzQ8m2gSoirqecT/jo1qmEggfpgAAAAASUVORK5CYII="

/***/ }),

/***/ "LWON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LbSN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LqCf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone3.950fb07.png";

/***/ }),

/***/ "M081":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mk4V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  mounted: function mounted() {
    if (this.$route.path === '/deposit3' || this.$route.path === '/bankcard' || this.$route.path === '/usdt3' || this.$route.path === '/usdt4') {
      document.body.classList.add('themed');
      if (sessionStorage.getItem('theme') === null) {
        document.body.classList.add('light');
      } else {
        if (sessionStorage.getItem('theme') === '0') {
          document.body.classList.remove('dark');
          document.body.classList.add('light');
        } else {
          document.body.classList.remove('light');
          document.body.classList.add('dark');
        }
      }
    } else if (this.$route.path === '/deposit1' || this.$route.path === '/deposit2') {
      document.body.classList.remove('dark');
      document.body.classList.remove('light');
      document.body.classList.remove('themed');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  mounted: function mounted() {
    if (this.$route.path === '/deposit3' || this.$route.path === '/bankcard' || this.$route.path === '/usdt3' || this.$route.path === '/usdt4') {
      document.body.classList.add('themed');
      if (sessionStorage.getItem('theme') === null) {
        document.body.classList.add('light');
      } else {
        if (sessionStorage.getItem('theme') === '0') {
          document.body.classList.remove('dark');
          document.body.classList.add('light');
        } else {
          document.body.classList.remove('light');
          document.body.classList.add('dark');
        }
      }
    } else if (this.$route.path === '/deposit1' || this.$route.path === '/deposit2') {
      document.body.classList.remove('dark');
      document.body.classList.remove('light');
      document.body.classList.remove('themed');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202ff7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("cAOh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("r/47")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfa359e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("G+8N")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26523019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("489H")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt1.vue





/* harmony default export */ var Usdt1 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt1.vue





/* harmony default export */ var components_Usdt1 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ef5780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usdt1.vue
var Usdt1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usdt1",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值教程","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('div',{staticClass:"content-ustd1"},[_c('img',{staticClass:"title",attrs:{"src":__webpack_require__("h7jX"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("充值类型选择“数字货币”—填写“金额”并确认支付—确认交易须知并点击同意—复制平台收币地址存入指定数量的USDT ERC20")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("Bzbw"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("tbht"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("Y/WX"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("cnJP"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("BBju"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("5")])])])],1)],2)],1)}
var Usdt1_staticRenderFns = []
var Usdt1_esExports = { render: Usdt1_render, staticRenderFns: Usdt1_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Usdt1 = (Usdt1_esExports);
// CONCATENATED MODULE: ./src/components/Usdt1.vue
function Usdt1_injectStyle (ssrContext) {
  __webpack_require__("hUmw")
}
var Usdt1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Usdt1___vue_template_functional__ = false
/* styles */
var Usdt1___vue_styles__ = Usdt1_injectStyle
/* scopeId */
var Usdt1___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Usdt1___vue_module_identifier__ = null
var Usdt1_Component = Usdt1_normalizeComponent(
  components_Usdt1,
  selectortype_template_index_0_src_components_Usdt1,
  Usdt1___vue_template_functional__,
  Usdt1___vue_styles__,
  Usdt1___vue_scopeId__,
  Usdt1___vue_module_identifier__
)

/* harmony default export */ var src_components_Usdt1 = (Usdt1_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7406b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("WSOB")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b59c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])]},{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("fFUN")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("XcBy")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var components_box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d06311b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/box/index.vue
var box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({margin:_vm.gap})},[_vm._t("default")],2)}
var box_staticRenderFns = []
var box_esExports = { render: box_render, staticRenderFns: box_staticRenderFns }
/* harmony default export */ var src_components_box = (box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/box/index.vue
var box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var box___vue_template_functional__ = false
/* styles */
var box___vue_styles__ = null
/* scopeId */
var box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var box___vue_module_identifier__ = null
var box_Component = box_normalizeComponent(
  components_box,
  src_components_box,
  box___vue_template_functional__,
  box___vue_styles__,
  box___vue_scopeId__,
  box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_box = (box_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("2HYF")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("ArfS")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var cell_props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("4o0c")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js + 1 modules
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("Hq6V")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(cell_props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(cell_props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f92ebd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show.apply(null, arguments)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])]},{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("IM0P")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("oXsw")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/cookie/index.js
var cookie = __webpack_require__("17Ff");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt2.vue
















/* harmony default export */ var Usdt2 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
    window.scrollTo(0, 0);
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt2.vue
















/* harmony default export */ var components_Usdt2 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
    window.scrollTo(0, 0);
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe463ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usdt2.vue
var Usdt2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usdt1",staticStyle:{"height":"100vh"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值教程","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('div',{staticClass:"content-ustd2"},[_c('div',{staticClass:"sect1 sect"},[_c('h4',[_vm._v("如何兑换和使用 USDT ERC20")]),_vm._v(" "),_c('div',{staticClass:"title-bg blue"},[_c('h3',[_vm._v("OTC365")])])]),_vm._v(" "),_c('div',{staticClass:"sect2 sect"},[_c('p',[_vm._v("OTC365 网注册地址: "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.otc365.com/download.html?utm_source=merchant&utm_medium=PPN&utm_campaign=download"}},[_vm._v("https://www.otc365.com/")])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("Ix82"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("lLR9"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("0IJG"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("1r8j"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("5")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("3ltW"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down",staticStyle:{"visibility":"hidden"}},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("1r8j"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"title-bg green"},[_c('h3',[_vm._v("HOUBI")])])]),_vm._v(" "),_c('div',{staticClass:"sect sect3"},[_c('div',{staticClass:"divider"},[_c('img',{staticClass:"arrow arrow-r",attrs:{"src":__webpack_require__("P1p9"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("购买USDT")]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-l",attrs:{"src":__webpack_require__("YAFA"),"alt":""}})]),_vm._v(" "),_c('p',[_vm._v("火币网注册地址："),_c('a',{attrs:{"href":"https://www.huobi.br.com"}},[_vm._v("https://www.huobi.br.com")]),_vm._v(" "),_c('br'),_vm._v("\n              填写注册的账号 密码")]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("/Uuf"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("/B3F"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("d20T"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])])])]),_vm._v(" "),_c('div',{staticClass:"divider divider2"},[_c('img',{staticClass:"arrow arrow-r",attrs:{"src":__webpack_require__("P1p9"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("提USDT")]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-l",attrs:{"src":__webpack_require__("YAFA"),"alt":""}})]),_vm._v(" "),_c('p',[_vm._v("火币网注册地址: "),_c('a',{attrs:{"href":"https://www.huobi.br.com"}},[_vm._v("https://www.huobi.br.com")])]),_vm._v(" "),_c('div',{staticClass:"cont-zip"},[_c('div',{staticClass:"dashline"}),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("cVoO"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("zOHV"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("t1QK"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("YYoF"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("5")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("CR46"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("6")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("aNUl"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("7")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("+Idm"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("8")])]),_vm._v(" "),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("78Zd"),"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"title-bg red"},[_c('h3',[_vm._v("温馨提示")])])]),_vm._v(" "),_c('div',{staticClass:"sect4 sect"},[_c('p',[_vm._v("1. 兑换价格实时更新，实际兑换价格以存币提交到链上为准。")]),_vm._v(" "),_c('p',[_vm._v("2. 您发起提币至上述地址后，需等待整个网络节点 上有一定的  确认数后，才会实际到帐。")]),_vm._v(" "),_c('p',[_vm._v("3. 请留意您发起提币的平台是否有收取手续费，如有，则实际到帐数量可能少于原提币数量。")]),_vm._v(" "),_c('p',[_vm._v("4. 请务必确认电脑及浏览器安全，防止信息被篡改或泄露。")])])])],1)],2)],1)}
var Usdt2_staticRenderFns = []
var Usdt2_esExports = { render: Usdt2_render, staticRenderFns: Usdt2_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Usdt2 = (Usdt2_esExports);
// CONCATENATED MODULE: ./src/components/Usdt2.vue
function Usdt2_injectStyle (ssrContext) {
  __webpack_require__("yYq8")
}
var Usdt2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Usdt2___vue_template_functional__ = false
/* styles */
var Usdt2___vue_styles__ = Usdt2_injectStyle
/* scopeId */
var Usdt2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Usdt2___vue_module_identifier__ = null
var Usdt2_Component = Usdt2_normalizeComponent(
  components_Usdt2,
  selectortype_template_index_0_src_components_Usdt2,
  Usdt2___vue_template_functional__,
  Usdt2___vue_styles__,
  Usdt2___vue_scopeId__,
  Usdt2___vue_module_identifier__
)

/* harmony default export */ var src_components_Usdt2 = (Usdt2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt3.vue





/* harmony default export */ var Usdt3 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt3.vue





/* harmony default export */ var components_Usdt3 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dabe72e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usdt3.vue
var Usdt3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usdt1",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值教程","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('div',{staticClass:"content-ustd1"},[_c('div',{staticClass:"title-cont"},[_c('div',{staticClass:"title1"})]),_vm._v(" "),_c('div',{staticClass:"divider-bg"}),_vm._v(" "),_c('p',[_vm._v("充值类型选择“数字货币”—填写“金额”并确认支付—确认交易须知并点击同意—复制平台收币地址存入指定数量的USDT ERC20")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("Qhem"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num num1"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("DCNY"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num num2"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("USOW"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num num3"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("2kw+"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num num4"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("w2p9"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"num num5"})])],1)],2)],1)}
var Usdt3_staticRenderFns = []
var Usdt3_esExports = { render: Usdt3_render, staticRenderFns: Usdt3_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Usdt3 = (Usdt3_esExports);
// CONCATENATED MODULE: ./src/components/Usdt3.vue
function Usdt3_injectStyle (ssrContext) {
  __webpack_require__("YMMG")
}
var Usdt3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Usdt3___vue_template_functional__ = false
/* styles */
var Usdt3___vue_styles__ = Usdt3_injectStyle
/* scopeId */
var Usdt3___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Usdt3___vue_module_identifier__ = null
var Usdt3_Component = Usdt3_normalizeComponent(
  components_Usdt3,
  selectortype_template_index_0_src_components_Usdt3,
  Usdt3___vue_template_functional__,
  Usdt3___vue_styles__,
  Usdt3___vue_scopeId__,
  Usdt3___vue_module_identifier__
)

/* harmony default export */ var src_components_Usdt3 = (Usdt3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt4.vue
















/* harmony default export */ var Usdt4 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
    window.scrollTo(0, 0);
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt4.vue
















/* harmony default export */ var components_Usdt4 = ({
  data: function data() {
    return {
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
    window.scrollTo(0, 0);
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9076fd76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usdt4.vue
var Usdt4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usdt2",staticStyle:{"height":"100vh"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值教程","left-options":{backText: ''}},slot:"header"}),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('div',{staticClass:"content-ustd2"},[_c('div',{staticClass:"sect1 sect"},[(false)?_c('h4',[_vm._v("如何兑换和使用 USDT ERC20")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"})]),_vm._v(" "),_c('div',{staticClass:"title-bg blue"},[(false)?_c('h3',[_vm._v("OTC365")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"})]),_vm._v(" "),_c('p',{staticClass:"par-title blue"},[_vm._v("OTC365 网注册地址: "),_c('br'),_c('a',{staticClass:"btn-link",attrs:{"href":"https://www.otc365.com/download.html?utm_source=merchant&utm_medium=PPN&utm_campaign=download"}},[_vm._v("下载")])]),_vm._v(" "),_c('div',{staticClass:"cont-padd"},[_c('div',{staticClass:"sect2 sect"},[_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])]),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("AQy6"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])]),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("e5wT"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])]),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("BzEj"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("v7FE"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"cont adjust-up"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("5")])]),_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("Pm1e"),"alt":""}})])]),_vm._v(" "),(false)?_c('div',{staticClass:"col adjust-down"},[_c('div',{staticClass:"ph-cont"},[_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])]),_c('img',{staticClass:"phones",attrs:{"src":require("../../static/images/guide/usdt2/004.png"),"alt":""}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"title-bg green"},[_c('div',{staticClass:"title"})]),_vm._v(" "),_c('div',{staticClass:"sect sect3"},[_c('div',{staticClass:"divider"},[_c('img',{staticClass:"arrow arrow-r",attrs:{"src":__webpack_require__("L3AK"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("购买USDT")]),_c('img',{staticClass:"arrow arrow-l",attrs:{"src":__webpack_require__("d3ut"),"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"par-title green"},[_vm._v("火币网注册地址："),_c('a',{attrs:{"href":"https://www.huobi.br.com"}},[_vm._v("https: //www.huobi.br.com")]),_vm._v(" "),_c('br'),_vm._v("\n            填写注册的账号 密码")]),_vm._v(" "),_c('div',{staticClass:"cont-padd custom-cont"},[_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("niMn"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num num1"})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("vOB+"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num num2"})]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("LqCf"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num num3"})])])]),_vm._v(" "),_c('div',{staticClass:"divider divider2"},[_c('img',{staticClass:"arrow arrow-r",attrs:{"src":__webpack_require__("L3AK"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("提USDT")]),_c('img',{staticClass:"arrow arrow-l",attrs:{"src":__webpack_require__("d3ut"),"alt":""}})]),_vm._v(" "),_c('p',[_vm._v("火币网注册地址: "),_c('a',{attrs:{"href":"https://www.huobi.br.com"}},[_vm._v("https: //www.huobi.br.com")])]),_vm._v(" "),_c('div',{staticClass:"cont-padd"},[_c('div',{staticClass:"cont-zip"},[_c('div',{staticClass:"dashline"}),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("xCNR"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("1")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("A4gA"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("2")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("9WAQ"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("3")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("RlBD"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("4")])])])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("rrTR"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("5")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("i20+"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("6")])])])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("yHrf"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("7")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"ph-cont"},[_c('img',{staticClass:"phones",attrs:{"src":__webpack_require__("6ciI"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"num"},[_c('span',[_vm._v("8")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"title-bg red"},[_c('div',{staticClass:"title"})]),_vm._v(" "),_c('div',{staticClass:"sect4 sect"},[_c('p',[_vm._v("1. 兑换价格实时更新，实际兑换价格以存币提交到链上为准。")]),_vm._v(" "),_c('p',[_vm._v("2. 您发起提币至上述地址后，需等待整个网络节点 上有一定的 确认数后，才会实际到帐。")]),_vm._v(" "),_c('p',[_vm._v("3. 请留意您发起提币的平台是否有收取手续费，如有，则实际到帐数量可能少于原提币数量。")]),_vm._v(" "),_c('p',[_vm._v("4. 请务必确认电脑及浏览器安全，防止信息被篡改或泄露。")])])])],1)],2)],1)}
var Usdt4_staticRenderFns = []
var Usdt4_esExports = { render: Usdt4_render, staticRenderFns: Usdt4_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Usdt4 = (Usdt4_esExports);
// CONCATENATED MODULE: ./src/components/Usdt4.vue
function Usdt4_injectStyle (ssrContext) {
  __webpack_require__("H7sN")
}
var Usdt4_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Usdt4___vue_template_functional__ = false
/* styles */
var Usdt4___vue_styles__ = Usdt4_injectStyle
/* scopeId */
var Usdt4___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Usdt4___vue_module_identifier__ = null
var Usdt4_Component = Usdt4_normalizeComponent(
  components_Usdt4,
  selectortype_template_index_0_src_components_Usdt4,
  Usdt4___vue_template_functional__,
  Usdt4___vue_styles__,
  Usdt4___vue_scopeId__,
  Usdt4___vue_module_identifier__
)

/* harmony default export */ var src_components_Usdt4 = (Usdt4_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt5.vue





/* harmony default export */ var Usdt5 = ({
  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Usdt5.vue





/* harmony default export */ var components_Usdt5 = ({
  components: {
    Loading: vux_src_components_loading,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab2a490","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usdt5.vue
var Usdt5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usdt5",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"0"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"了解虚拟币","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('div',{staticClass:"content-ustd5"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"title",attrs:{"src":__webpack_require__("esPN"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('table',[_c('tr',[_c('td',[_c('div',{staticClass:"diamond"})]),_vm._v(" "),_c('td',[_vm._v("\n                              虚拟币是一种不具备实体形式的、仅以数字形式存在的货币，也称之为“数字货币”。\n                          ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"diamond"})]),_vm._v(" "),_c('td',[_vm._v("\n                              其性质与实体货币相似，允许在互联网上即时地、无地理限制地转让，主流的数字货币如USDT(泰达币)、BTC(比特币)、ETH(以太坊)等。\n                          ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"diamond"})]),_vm._v(" "),_c('td',[_vm._v("\n                              用户可以通过数字货币交易平台购买数字货币，在平台进行支付、兑换成人民币从而进行游戏。\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"content content2"},[_c('img',{staticClass:"title",attrs:{"src":__webpack_require__("u7uk"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('table',[_c('tr',[_c('td',[_c('div',{staticClass:"icon1 icon"})]),_vm._v(" "),_c('td',[_c('h4',[_vm._v("高度加密")]),_vm._v("\n                              与银行卡等传统交易方式相比，玩家不需要给出自己的姓名或卡号即可完成虚拟币交易，避免敏感信息泄露。\n                          ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"icon3 icon"})]),_vm._v(" "),_c('td',[_c('h4',[_vm._v("交易快速")]),_vm._v("\n                              虚拟币所采用的区块链技术具有去中心化特点，不需要清算中心机构来处理数据，交易时间大大缩短。\n                          ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"icon4 icon"})]),_vm._v(" "),_c('td',[_c('h4',[_vm._v("去中心化")]),_vm._v("\n                              不由央行或当局发行，不受银行监管，玩家可随心所欲地使用存放在自己数字钱包里的资金。\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"content content3"},[_c('img',{staticClass:"title",attrs:{"src":__webpack_require__("PZ4B"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('table',[_c('tr',[_c('td',[_c('div',{staticClass:"diamond"})]),_vm._v(" "),_c('td',[_vm._v("\n                              泰达币（Tether）也被称为USDT，其价值等同于美元。1 USDT≈1 美元，该特点使USDT成为全球加密数字货币中规模最大、流通性最高的稳定币，具有良好的保值性，也是网站所使用的主要币种。\n                          ")])])]),_vm._v(" "),_c('table',{staticClass:"table2"},[_c('tr',[_c('td',[_c('div',{staticClass:"icon2 icon"})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("XBIu"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("g4bv"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("JCrt"),"alt":""}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"icon5 icon"})]),_vm._v(" "),_c('td',[_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("Rg/T"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("JxW2"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("62Xp"),"alt":""}})])])])])]),_vm._v(" "),_c('div',{staticClass:"content content4"},[_c('a',{attrs:{"href":"/usdt1"}},[_vm._v("充值教程")])])])],1)],2)],1)}
var Usdt5_staticRenderFns = []
var Usdt5_esExports = { render: Usdt5_render, staticRenderFns: Usdt5_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Usdt5 = (Usdt5_esExports);
// CONCATENATED MODULE: ./src/components/Usdt5.vue
function Usdt5_injectStyle (ssrContext) {
  __webpack_require__("M081")
}
var Usdt5_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Usdt5___vue_template_functional__ = false
/* styles */
var Usdt5___vue_styles__ = Usdt5_injectStyle
/* scopeId */
var Usdt5___vue_scopeId__ = "data-v-6ab2a490"
/* moduleIdentifier (server only) */
var Usdt5___vue_module_identifier__ = null
var Usdt5_Component = Usdt5_normalizeComponent(
  components_Usdt5,
  selectortype_template_index_0_src_components_Usdt5,
  Usdt5___vue_template_functional__,
  Usdt5___vue_styles__,
  Usdt5___vue_scopeId__,
  Usdt5___vue_module_identifier__
)

/* harmony default export */ var src_components_Usdt5 = (Usdt5_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/constants/lang.js
var LANG = {
  0: 'en',
  1: 'en',
  2: 'cn',
  3: 'tw',
  4: 'vn'
};

var SURNAMES = ['乙', '丁', '乃', '乜', '九', '刀', '刁', '力', '卜', '万', '万俟', '上', '上官', '义', '么', '习', '于', '兀', '凡', '千', '卫', '士', '夕', '大', '子', '子车', '寸', '山', '己', '干', '幺', '广', '弋', '弓', '才', '门', '飞', '马', '马佳', '不', '丑', '中', '丰', '丹', '之', '乌', '乌孙', '乌雅', '尹', '书', '云', '亓', '亓官', '五', '井', '亢', '仁', '仆', '仇', '仉', '介', '仍', '从', '仓', '允', '元', '公', '公孙', '公羊', '公西', '公冶', '公良', '公叔', '六', '凤', '勾', '化', '区', '升', '卞', '历', '及', '友', '双', '壬', '天', '太', '太史', '太叔', '夫', '孔', '少', '尤', '巴', '开', '戈', '户', '支', '文', '方', '无', '日', '月', '木', '止', '殳', '毋', '毛', '水', '火', '牙', '牛', '王', '见', '计', '贝', '车', '韦', '风', '世', '丘', '丙', '业', '丛', '东', '东门', '东方', '东郭', '主', '乐', '乐正', '他塔喇', '付', '仙', '仝', '代', '令', '令狐', '以', '仪', '充', '兰', '冉', '冬', '冯', '出', '功', '加', '务', '包', '北', '占', '卡', '卢', '卯', '厉', '古', '句', '另', '只', '召', '可', '台', '史', '叶', '叶赫那兰', '叶赫那拉', '司', '司马', '司空', '司徒', '司寇', '圣', '宁', '尔', '尼', '左', '左丘', '巧', '巨', '市', '布', '帅', '平', '弘', '归', '戊', '旦', '未', '本', '正', '母', '永', '汉', '玄', '玉', '瓜尔佳', '甘', '生', '用', '田', '由', '甲', '申', '申屠', '白', '皮', '矢', '石', '示', '禾', '立', '让', '记', '邓', '长', '长孙', '闪', '龙', '乔', '买', '亥', '产', '仰', '仲', '仲孙', '仵', '任', '伊', '伍', '伏', '休', '伙', '会', '伞', '伟', '传', '伦', '兆', '先', '光', '全', '关', '兴', '军', '农', '刑', '列', '刘', '刘付', '刘傅', '刚', '匡', '华', '印', '危', '厍', '吁', '合', '吉', '同', '名', '后', '向', '吕', '回', '在', '圭', '壮', '夙', '多', '夷', '夹谷', '好', '如', '字', '孙', '宇', '宇文', '守', '安', '寻', '尧', '巩', '师', '年', '庄', '庆', '戎', '戏', '成', '扬', '曲', '有', '朱', '朴', '朵', '机', '权', '次', '毕', '汗', '汝', '江', '池', '汤', '牟', '百', '百里', '礼', '竹', '米', '红', '纪', '羊', '羊舌', '羽', '老', '考', '自', '艾', '节', '行', '衣', '西', '西门', '讷殷富察', '许', '边', '邗', '邛', '邝', '闫', '闭', '问', '齐', '严', '丽', '伯', '似', '佃', '但', '位', '佐', '何', '佘', '余', '佛', '佟', '佟佳', '克', '况', '冶', '冷', '冷狐', '初', '利', '别', '励', '劳', '卲', '却', '君', '吝', '吴', '吾', '呈', '告', '员', '呙', '坚', '声', '妙', '妫', '孛', '孝', '宋', '完', '完颜', '宏', '寿', '尾', '局', '岑', '巫', '巫马', '希', '庐', '库', '库雅喇', '应', '张', '张简', '张廖', '彤', '忻', '怀', '扶', '抄', '把', '抗', '折', '改', '时', '旷', '李', '杜', '杞', '束', '来', '杨', '步', '求', '汪', '汲', '沃', '沈', '沉', '沐', '沙', '牢', '犹', '狂', '狄', '甫', '疗', '系', '纳', '纳兰', '纳喇', '纵', '罕', '肖', '良', '芒', '言', '谷', '谷梁', '豆', '贡', '赤', '轩', '轩辕', '辛', '达', '迂', '过', '邢', '那', '那拉', '邦', '邬', '里', '针', '钊', '闰', '闳', '闵', '阮', '阳', '阴', '阵', '麦', '京', '佳', '佴', '佼', '侍', '供', '依', '依尔觉罗', '依尔根觉罗', '侣', '侥', '侨', '其', '具', '典', '冼', '凭', '凯', '函', '势', '卑', '卓', '单', '单于', '卷', '叔', '受', '周', '呼', '呼延', '和', '咎', '国', '图门', '奇', '奈', '奉', '始', '姒', '姓', '委', '孟', '季', '学', '宓', '宗', '宗政', '官', '定', '宛', '宜', '宝', '实', '尚', '居', '屈', '岩', '岳', '帖', '帛', '幸', '底', '庚', '府', '庞', '延', '弥', '征', '忠', '念', '忽', '怡', '性', '房', '所', '承', '拓', '拓跋', '招', '斩', '於', '旺', '昂', '昊', '昌', '明', '易', '昔', '朋', '杭', '杰', '杲', '松', '板', '析', '林', '枚', '果', '枝', '欧', '欧阳', '武', '歧', '殴阳', '河', '油', '治', '法', '泠', '波', '泣', '泥', '泮', '泷', '炉', '牧', '环', '畅', '祁', '空', '竺', '线', '练', '终', '绍', '经', '罗', '羌', '肥', '芦', '芮', '花', '芳', '苌', '苍', '苏', '虎', '补', '表', '诗', '贤', '贯', '运', '还', '进', '远', '连', '迟', '邰', '邱', '邴', '邵', '邶', '邸', '邹', '采', '金', '阿', '陀', '陆', '陈', '青', '驹', '鱼', '侯', '俊', '俎', '保', '俞', '俟', '信', '养', '冒', '冠', '前', '剑', '勇', '南', '南门', '南宫', '厚', '咸', '哀', '哈', '城', '复', '奎', '奕', '姚', '姜', '威', '娇', '宣', '宦', '宫', '封', '将', '度', '建', '弭', '彦', '律', '思', '恒', '恽', '战', '拜', '拱', '拾', '政', '施', '昝', '星', '春', '是', '柏', '柒', '柔', '查', '柯', '柳', '栋', '树', '段', '段干', '泉', '洋', '洑', '洗', '洛', '洪', '浑', '牵', '独', '独孤', '瓮', '甚', '皇', '皇甫', '盈', '相', '祈', '禹', '秋', '种', '科', '笃', '娄', '类', '绕', '美', '羿', '胡', '胥', '苑', '苗', '苟', '若', '苦', '英', '苻', '茂', '范', '范姜', '茅', '茆', '蚁', '要', '说', '贰', '贲', '贵', '贸', '费', '费莫', '贺', '赵', '迪', '迮', '邾', '郁', '郄', '郅', '郇', '郎', '郏', '郐', '郑', '钞', '钟', '钟离', '钦', '钭', '钮', '钮祜禄', '闻', '闻人', '闽', '闾', '闾丘', '降', '陕', '革', '项', '顺', '须', '饶', '首', '香', '骆', '骈', '鸥', '乘', '修', '俱', '俸', '候', '倡', '倪', '党', '凌', '剧', '卿', '原', '唐', '夏', '夏侯', '夏候', '奚', '姬', '娜', '宰', '宰父', '宴', '宵', '家', '容', '宾', '展', '席', '徐', '徒', '恩', '恭', '息', '悟', '悦', '斋', '旁', '旅', '晁', '晋', '晏', '晓', '朗', '柴', '栗', '校', '样', '格', '栾', '桂', '桃', '桐', '桑', '桓', '桥', '殷', '泰', '浦', '浩', '浮', '海', '涂', '润', '烟', '爱', '爱新觉罗', '珠', '班', '留', '皋', '皱', '益', '盍', '真', '祖', '祝', '神', '祢', '秘', '秦', '称', '素', '索', '索绰络', '继', '翁', '耆', '耿', '聂', '能', '艳', '茶', '茹', '荀', '荚', '荛', '荣', '荤', '药', '衷', '袁', '诸', '诸葛', '诺', '谈', '贾', '资', '载', '送', '逄', '郗', '郜', '郝', '郦', '酒', '钱', '铁', '铎', '院', '除', '隽', '顼', '顾', '顿', '高', '乾', '偶', '勒', '勘', '唱', '商', '啜', '基', '堂', '堵', '宿', '密', '寇', '尉', '尉迟', '屠', '崇', '崔', '巢', '常', '康', '庹', '庾', '彩', '御', '悉', '戚', '扈', '捷', '接', '敏', '敕', '敖', '教', '敛', '斛', '晨', '曽', '曹', '曼', '望', '梁', '梁丘', '梅', '梦', '梨', '检', '淘', '淡', '淦', '淮', '淳', '淳于', '清', '焉', '犁', '理', '盖', '盘', '盛', '眭', '矫', '硕', '祭', '符', '笪', '第', '第五', '粘', '绪', '续', '绳', '绿', '聊', '职', '脱', '荷', '莘', '莫', '莱', '莲', '衅', '袭', '谌', '谏', '赧', '通', '速', '逢', '部', '郭', '郯', '郸', '都', '野', '铙', '银', '阎', '陶', '雀', '雪', '章', '章佳', '骑', '鸿', '鹿', '麻', '龚', '傅', '储', '博', '厦', '善', '喇', '喜', '喜塔腊', '喻', '堪', '奥', '富', '富察', '寒', '嵇', '强', '彭', '惠', '掌', '提', '揣', '揭', '敦', '斐', '斯', '普', '景', '智', '曾', '朝', '森', '植', '楮', '渠', '温', '游', '湖', '湘', '湛', '焦', '琚', '琦', '琴', '甯', '番', '疏', '登', '禄', '稂', '程', '税', '童', '答', '粟', '紫', '缑', '舒', '舒穆禄', '舜', '荆', '菅', '菇', '菊', '菜', '萧', '蛮', '覃', '谢', '象', '赏', '超', '越', '辉', '辜', '逮', '逯', '鄂', '释', '锁', '锐', '阔', '隆', '隋', '隐', '雄', '雅', '集', '韩', '颉', '鲁', '黄', '黑', '催', '傲', '勤', '塔', '塘', '塞', '廉', '徭', '微生', '愈', '愚', '慎', '戢', '摆', '敬', '楚', '楼', '毓', '源', '溥', '溪', '滑', '满', '瑞', '睢', '督', '睦', '禽', '窦', '简', '粱', '腾', '营', '萨', '萨克达', '萨嘛喇', '葛', '董', '蒉', '蒋', '虞', '裔', '裘', '解', '訾', '詹', '誉', '谬', '貊', '赖', '路', '辟', '遆', '遇', '道', '错', '阙', '随', '隗', '雍', '零', '雷', '靖', '靳', '频', '鲍', '僧', '僪', '嘉', '寥', '廖', '慈', '旗', '暨', '槐', '漆', '漆雕', '漫', '潇', '熊', '甄', '碧', '碧鲁', '福', '竭', '端', '端木', '箕', '管', '箫', '綦', '缪', '翟', '翠', '肇', '臧', '蒙', '蒯', '蒲', '蒿', '蓝', '蓟', '裴', '褚', '谭', '谯', '赛', '赫', '赫舍里', '赫连', '鄞', '鄢', '锺', '锺离', '阚', '雒', '静', '韶', '鲜', '鲜于', '增', '德', '慕', '慕容', '摩', '撒', '暴', '樊', '滕', '潘', '潜', '潭', '潮', '澄', '澎', '熬', '禚', '稽', '翦', '蓬', '蔚', '蔡', '蔺', '虢', '褒', '镇', '颛孙', '颜', '额尔德特', '黎', '墨', '冀', '嬴', '徼', '操', '澹台', '燕', '瘳', '磨', '禤', '穆', '缴', '融', '衡', '镜', '霍', '默', '懂', '戴', '檀', '濮', '濮阳', '濯', '璩', '甑', '糜', '繁', '翼', '蕾', '薄', '薛', '薜', '謇', '蹇', '蹉', '霜', '霞', '鞠', '瞿', '藏', '魏', '攀', '藤', '藩', '麴', '壤驷', '矍', '籍', '夔', '巍', '酆', '穰', '爨', '茌'];
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DynamicInput.vue



/* harmony default export */ var DynamicInput = ({
  components: {
    XInput: vux_src_components_x_input
  },
  props: {
    fields: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formData: {}, // 用來存儲每個輸入框的值
      errors: {}
    };
  },
  created: function created() {
    var _this = this;

    this.fields.forEach(function (field) {
      _this.formData[field.name] = '';
      _this.errors[field.name] = null;
    });
  },

  methods: {
    validator: function validator(field) {
      var regex = new RegExp(field.regex);
      if (!regex.test(this.formData[field.name])) {
        this.$set(this.errors, field.name, this.$t('' + field.name) + ' ' + this.$t('formatWrong'));
      } else {
        this.$delete(this.errors, field.name);
      }
    }
  },
  watch: {
    formData: {
      deep: true,
      handler: function handler(newFormData) {
        this.$emit('update:formData', newFormData);
        this.$emit('update:errors', this.errors);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DynamicInput.vue



/* harmony default export */ var components_DynamicInput = ({
  components: {
    XInput: vux_src_components_x_input
  },
  props: {
    fields: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formData: {}, // 用來存儲每個輸入框的值
      errors: {}
    };
  },
  created: function created() {
    var _this = this;

    this.fields.forEach(function (field) {
      _this.formData[field.name] = '';
      _this.errors[field.name] = null;
    });
  },

  methods: {
    validator: function validator(field) {
      var regex = new RegExp(field.regex);
      if (!regex.test(this.formData[field.name])) {
        this.$set(this.errors, field.name, this.$t('' + field.name) + ' ' + this.$t('formatWrong'));
      } else {
        this.$delete(this.errors, field.name);
      }
    }
  },
  watch: {
    formData: {
      deep: true,
      handler: function handler(newFormData) {
        this.$emit('update:formData', newFormData);
        this.$emit('update:errors', this.errors);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e5d54a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicInput.vue
var DynamicInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fields),function(field){return _c('div',{key:field.name},[_c('x-input',{attrs:{"title":("" + (_vm.$t(("" + (field.placeholder))))),"placeholder":("" + (_vm.$t(("" + (field.placeholder)))))},on:{"on-change":function($event){return _vm.validator(field)}},model:{value:(_vm.formData[field.name]),callback:function ($$v) {_vm.$set(_vm.formData, field.name, $$v)},expression:"formData[field.name]"}}),_vm._v(" "),(_vm.errors[field.name])?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errors[field.name]))]):_vm._e()],1)}),0)}
var DynamicInput_staticRenderFns = []
var DynamicInput_esExports = { render: DynamicInput_render, staticRenderFns: DynamicInput_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_DynamicInput = (DynamicInput_esExports);
// CONCATENATED MODULE: ./src/components/DynamicInput.vue
function DynamicInput_injectStyle (ssrContext) {
  __webpack_require__("QxhP")
}
var DynamicInput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DynamicInput___vue_template_functional__ = false
/* styles */
var DynamicInput___vue_styles__ = DynamicInput_injectStyle
/* scopeId */
var DynamicInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DynamicInput___vue_module_identifier__ = null
var DynamicInput_Component = DynamicInput_normalizeComponent(
  components_DynamicInput,
  selectortype_template_index_0_src_components_DynamicInput,
  DynamicInput___vue_template_functional__,
  DynamicInput___vue_styles__,
  DynamicInput___vue_scopeId__,
  DynamicInput___vue_module_identifier__
)

/* harmony default export */ var src_components_DynamicInput = (DynamicInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit.vue



















/* harmony default export */ var Deposit = ({
  components: {
    DynamicInput: src_components_DynamicInput,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      moreIcons: ['unionpay', 'alipay', 'wechat', 'high-price', 'multiplex', 'coinpay', 'union_multi'],
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: '',
        symbol: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      languageslist: [{
        key: 'cn',
        value: 'zh_CN'
      }, {
        key: 'tw',
        value: 'zh_TW'
      }, {
        key: 'en',
        value: 'EN'
      }, {
        key: 'vn',
        value: 'VN'
      }],
      selectoption: '',
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      showload: false,
      custom_fields: [],
      custom: {},
      custom_errors: {}
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    window.onbeforeunload = function (e) {
      var storage = window.localStorage;
      storage.clear();
    };

    this.setLocale();
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      var _platforms$data$data = platforms.data.data,
          hasDeposit = _platforms$data$data.has_deposit,
          appOrderNumber = _platforms$data$data.app_order_no,
          ipBlocked = _platforms$data$data.ip_blocked;

      if (ipBlocked) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('ipBlock'),
            description1: '' + self.$t('error')
          }
        });
        return;
      }

      if (platforms.data.data === undefined || platforms.data.data === '') {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('orderUnavailable'),
            description1: '' + self.$t('error')
          }
        });
        return;
      }

      if (hasDeposit) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('requestAgain'),
            description1: self.$t('orderNumber') + '\uFF1A' + appOrderNumber
          }
        });
        return;
      }

      platforms = platforms.data.data;
      if (platforms.platforms.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('channelMaintain'),
            description1: self.$t('orderNumber') + '\uFF1A' + appOrderNumber
          }
        });
        return;
      }

      if (typeof platforms.platform_id !== 'undefined' && platforms.platform_id !== null) {
        self.platform_name = platforms.platform.name;
        self.showChoosePlatform = false;
        self.platform_key = platforms.platform.platform_id;

        if (platforms.platform.need_bank === 1 && platforms.platform.bank_id === '') {
          self.showBankSelect = true;
          var banks = [];
          for (var id in platforms.platform.banks) {
            var val = platforms.platform.banks[id];
            banks = banks.concat([{
              key: id,
              value: val.name
            }]);
          }
          self.banks = banks;
        }
        var platform = platforms.platforms[0];
        self.platforms = self.platforms.concat({
          key: platform.id,
          value: platform.name,
          need_bank: platform.need_bank,
          bank_id: platform.bank_id,
          max_load: platform.max_load,
          min_load: platform.min_load,
          icon: 'static/images/logo/' + platform.icon + '.png',
          show: platform.hasOwnProperty('show') ? {
            content: platform.show.content,
            type: platform.show.type,
            link: platform.show[platform.show.type]
          } : null,
          banks: platform.banks,
          need_name: platform.need_name,
          need_mobile: platform.need_mobile,
          symbol: platform.symbol,
          custom_fields: platform.custom_fields
        });
        self.platforms_hash[platforms.platform.platform_id] = platforms.platform;
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _platform = _step.value;

            var mobileShow, mobileDefault;
            if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
              if (navigator.userAgent.indexOf('Android') > -1) {
                mobileShow = _platform.android_show;
                mobileDefault = _platform.android_default;
              } else {
                mobileShow = _platform.ios_show;
                mobileDefault = _platform.ios_default;
              }
            } else {
              mobileShow = _platform.pc_show;
              mobileDefault = _platform.pc_default;
            }
            var platformObj = {
              show_view: Boolean(mobileShow),
              default_show: Boolean(mobileDefault),
              key: _platform.id,
              value: _platform.name,
              description: _platform.description,
              need_bank: _platform.need_bank,
              bank_id: _platform.bank_id,
              max_load: _platform.max_load,
              min_load: _platform.min_load,
              icon: 'static/images/logo/' + _platform.icon + '.png',
              show: _platform.hasOwnProperty('show') ? {
                content: _platform.show.content,
                type: _platform.show.type,
                link: _platform.show[_platform.show.type]
              } : null,
              banks: _platform.banks,
              amount_list: _platform.custom_amounts,
              static_amount: _platform.static_amount,
              succ_percent: _platform.succ_percent,
              need_name: _platform.need_name,
              need_mobile: _platform.need_mobile,
              symbol: '' || _platform.symbol,
              custom_fields: _platform.custom_fields
            };
            if (platformObj.show_view) {
              self.platforms = self.platforms.concat(platformObj);
            }
            self.platforms_hash[platformObj.key] = platformObj;

            if (platformObj.default_show) {
              self.platform_key = platformObj.key;
              self.platform = platformObj;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (self.platforms.length === 0) {
          self.$router.replace({
            path: '/error',
            query: {
              title: '' + self.$t('channelUnavailable'),
              description1: self.$t('order') + '\uFF1A' + platforms.app_order_no,
              description2: self.$t('paymentType') + '\uFF1A' + platforms.type
            }
          });
          return;
        } else if (self.platforms.length === 1) {
          self.platform_key = self.platforms[0].key;
          self.platform_name = self.platforms[0].value;
        } else if (self.platforms.length > 1) {
          self.showChoosePlatform = true;
          self.showPlatform = true;
        }

        self.checkBank();
      }

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var _this = this;

      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      var chineseReg = /^[\u4e00-\u9fa5]{2,}$/;

      if (this.custom_fields.length) {
        if (keys_default()(this.custom_errors).length) {
          this.$vux.toast.show({
            'text': this.$t('fixWrong') + '\uFF01',
            'type': 'warn'
          });
          return;
        }
      }

      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': this.$t('enterRealName') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && (!chineseReg.test(this.yourname) || !(SURNAMES.find(function (el) {
        return el === _this.yourname.substr(0, 1) || el === _this.yourname.substr(0, 2);
      }) || '').length > 0)) {
        this.$vux.toast.show({
          'text': this.$t('invalidName') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': this.$t('enterPhone') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.showload = true;
          this.submit(submitAmout);
          setTimeout(function () {
            _this.showload = false;
          }, 3000);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;

      var payload = this.preparePayload(submitAmout);

      self.$models.Deposit.create(payload).then(function (response) {
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });
          self.pay_click = false;
          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2 && [2, 99].includes(response.data.data.locale_id)) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url
            }
          });
          self.pay_click = false;
          return;
        } else if (response.data.data.load_straight === 2 && response.data.data.locale_id === 1) {
          self.$router.replace({
            path: './order',
            query: {
              order_no: response.data.data.order_no
            }
          });
          self.pay_click = false;

          return;
        } else if (response.data.data.load_straight === 3) {
          self.$router.replace({
            path: './c2c',
            query: {
              amount: 200,
              cardNumber: 'test-card-number',
              transId: 'TX-00000001',
              owner: '陈一二',
              deadline: '2022-03-01 05:12:13'
            }
          });
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
          self.pay_click = false;
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        self.custom_fields = platform.custom_fields;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    setLocale: function setLocale() {
      var _this2 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this2.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this2.$i18n.locale = lang;
        }

        _this2.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;

      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languageslist = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    },
    preparePayload: function preparePayload(amount) {
      var self = this;

      return this.custom_fields.length ? {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no,
        custom: self.custom
      } : {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit.vue



















/* harmony default export */ var components_Deposit = ({
  components: {
    DynamicInput: src_components_DynamicInput,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio
  },
  data: function data() {
    return {
      moreIcons: ['unionpay', 'alipay', 'wechat', 'high-price', 'multiplex', 'coinpay', 'union_multi'],
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: '',
        symbol: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      languageslist: [{
        key: 'cn',
        value: 'zh_CN'
      }, {
        key: 'tw',
        value: 'zh_TW'
      }, {
        key: 'en',
        value: 'EN'
      }, {
        key: 'vn',
        value: 'VN'
      }],
      selectoption: '',
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      showload: false,
      custom_fields: [],
      custom: {},
      custom_errors: {}
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    window.onbeforeunload = function (e) {
      var storage = window.localStorage;
      storage.clear();
    };

    this.setLocale();
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      var _platforms$data$data = platforms.data.data,
          hasDeposit = _platforms$data$data.has_deposit,
          appOrderNumber = _platforms$data$data.app_order_no,
          ipBlocked = _platforms$data$data.ip_blocked;

      if (ipBlocked) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('ipBlock'),
            description1: '' + self.$t('error')
          }
        });
        return;
      }

      if (platforms.data.data === undefined || platforms.data.data === '') {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('orderUnavailable'),
            description1: '' + self.$t('error')
          }
        });
        return;
      }

      if (hasDeposit) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('requestAgain'),
            description1: self.$t('orderNumber') + '\uFF1A' + appOrderNumber
          }
        });
        return;
      }

      platforms = platforms.data.data;
      if (platforms.platforms.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: '' + self.$t('channelMaintain'),
            description1: self.$t('orderNumber') + '\uFF1A' + appOrderNumber
          }
        });
        return;
      }

      if (typeof platforms.platform_id !== 'undefined' && platforms.platform_id !== null) {
        self.platform_name = platforms.platform.name;
        self.showChoosePlatform = false;
        self.platform_key = platforms.platform.platform_id;

        if (platforms.platform.need_bank === 1 && platforms.platform.bank_id === '') {
          self.showBankSelect = true;
          var banks = [];
          for (var id in platforms.platform.banks) {
            var val = platforms.platform.banks[id];
            banks = banks.concat([{
              key: id,
              value: val.name
            }]);
          }
          self.banks = banks;
        }
        var platform = platforms.platforms[0];
        self.platforms = self.platforms.concat({
          key: platform.id,
          value: platform.name,
          need_bank: platform.need_bank,
          bank_id: platform.bank_id,
          max_load: platform.max_load,
          min_load: platform.min_load,
          icon: 'static/images/logo/' + platform.icon + '.png',
          show: platform.hasOwnProperty('show') ? {
            content: platform.show.content,
            type: platform.show.type,
            link: platform.show[platform.show.type]
          } : null,
          banks: platform.banks,
          need_name: platform.need_name,
          need_mobile: platform.need_mobile,
          symbol: platform.symbol,
          custom_fields: platform.custom_fields
        });
        self.platforms_hash[platforms.platform.platform_id] = platforms.platform;
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _platform = _step.value;

            var mobileShow, mobileDefault;
            if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
              if (navigator.userAgent.indexOf('Android') > -1) {
                mobileShow = _platform.android_show;
                mobileDefault = _platform.android_default;
              } else {
                mobileShow = _platform.ios_show;
                mobileDefault = _platform.ios_default;
              }
            } else {
              mobileShow = _platform.pc_show;
              mobileDefault = _platform.pc_default;
            }
            var platformObj = {
              show_view: Boolean(mobileShow),
              default_show: Boolean(mobileDefault),
              key: _platform.id,
              value: _platform.name,
              description: _platform.description,
              need_bank: _platform.need_bank,
              bank_id: _platform.bank_id,
              max_load: _platform.max_load,
              min_load: _platform.min_load,
              icon: 'static/images/logo/' + _platform.icon + '.png',
              show: _platform.hasOwnProperty('show') ? {
                content: _platform.show.content,
                type: _platform.show.type,
                link: _platform.show[_platform.show.type]
              } : null,
              banks: _platform.banks,
              amount_list: _platform.custom_amounts,
              static_amount: _platform.static_amount,
              succ_percent: _platform.succ_percent,
              need_name: _platform.need_name,
              need_mobile: _platform.need_mobile,
              symbol: '' || _platform.symbol,
              custom_fields: _platform.custom_fields
            };
            if (platformObj.show_view) {
              self.platforms = self.platforms.concat(platformObj);
            }
            self.platforms_hash[platformObj.key] = platformObj;

            if (platformObj.default_show) {
              self.platform_key = platformObj.key;
              self.platform = platformObj;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (self.platforms.length === 0) {
          self.$router.replace({
            path: '/error',
            query: {
              title: '' + self.$t('channelUnavailable'),
              description1: self.$t('order') + '\uFF1A' + platforms.app_order_no,
              description2: self.$t('paymentType') + '\uFF1A' + platforms.type
            }
          });
          return;
        } else if (self.platforms.length === 1) {
          self.platform_key = self.platforms[0].key;
          self.platform_name = self.platforms[0].value;
        } else if (self.platforms.length > 1) {
          self.showChoosePlatform = true;
          self.showPlatform = true;
        }

        self.checkBank();
      }

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var _this = this;

      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      var chineseReg = /^[\u4e00-\u9fa5]{2,}$/;

      if (this.custom_fields.length) {
        if (keys_default()(this.custom_errors).length) {
          this.$vux.toast.show({
            'text': this.$t('fixWrong') + '\uFF01',
            'type': 'warn'
          });
          return;
        }
      }

      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': this.$t('enterRealName') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && (!chineseReg.test(this.yourname) || !(SURNAMES.find(function (el) {
        return el === _this.yourname.substr(0, 1) || el === _this.yourname.substr(0, 2);
      }) || '').length > 0)) {
        this.$vux.toast.show({
          'text': this.$t('invalidName') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': this.$t('enterPhone') + '\uFF01',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.showload = true;
          this.submit(submitAmout);
          setTimeout(function () {
            _this.showload = false;
          }, 3000);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;

      var payload = this.preparePayload(submitAmout);

      self.$models.Deposit.create(payload).then(function (response) {
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });
          self.pay_click = false;
          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2 && [2, 99].includes(response.data.data.locale_id)) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url
            }
          });
          self.pay_click = false;
          return;
        } else if (response.data.data.load_straight === 2 && response.data.data.locale_id === 1) {
          self.$router.replace({
            path: './order',
            query: {
              order_no: response.data.data.order_no
            }
          });
          self.pay_click = false;

          return;
        } else if (response.data.data.load_straight === 3) {
          self.$router.replace({
            path: './c2c',
            query: {
              amount: 200,
              cardNumber: 'test-card-number',
              transId: 'TX-00000001',
              owner: '陈一二',
              deadline: '2022-03-01 05:12:13'
            }
          });
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
          self.pay_click = false;
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        self.custom_fields = platform.custom_fields;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    setLocale: function setLocale() {
      var _this2 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this2.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this2.$i18n.locale = lang;
        }

        _this2.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;

      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languageslist = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    },
    preparePayload: function preparePayload(amount) {
      var self = this;

      return this.custom_fields.length ? {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no,
        custom: self.custom
      } : {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0e2264","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit.vue
var Deposit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"chooselang"},[_c('img',{attrs:{"src":__webpack_require__("q29H"),"alt":"language"}}),_vm._v(" "),_c('div',{staticClass:"langcon"},[_c('popup-radio',{attrs:{"title":"","options":_vm.languageslist},on:{"on-hide":_vm.switchLang},model:{value:(_vm.selectoption),callback:function ($$v) {_vm.selectoption=$$v},expression:"selectoption"}},[_c('p',{staticClass:"popupheadercon",attrs:{"slot":"popup-header"},slot:"popup-header"},[_vm._v(_vm._s(_vm.$t('chooseLanguage')))])])],1)]),_vm._v(" "),_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":_vm.$t('payment'),"left-options":{showBack: false, backText: ''},"right-options":{showMore: false}},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.$t('choosePaymentMethod')))])]),_vm._v(" "),_c('template',{slot:"default"},[_c('group',{attrs:{"gutter":"10px","title":((_vm.$t('order')) + "：" + _vm.app_order_no)}},[(_vm.showChoosePlatform)?_c('group',{attrs:{"gutter":"0px","title":((_vm.$t('choosePaymentMethod')) + "：")}},[_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){_vm.showPlatform = true}}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.platform.value))]),_vm._v(" "),_c('img',{staticClass:"rmargin-10px",staticStyle:{"margin-right":"10px"},attrs:{"slot":"icon","width":"50","src":_vm.platform.icon},slot:"icon"})]),_vm._v(" "),_c('cell',{staticClass:"morepay",nativeOn:{"click":function($event){_vm.showPlatform = true}}},[_vm._l((_vm.moreIcons),function(item){return [_c('img',{attrs:{"slot":"icon","src":("../../static/images/logo/" + item + ".png"),"width":"22","alt":"item"},slot:"icon"})]}),_vm._v("\n            "+_vm._s(_vm.$t('moreOptions'))+"  >\n          ")],2)],1):_c('x-input',{attrs:{"title":("" + (_vm.$t('paymentMethod'))),"disabled":true,"value":_vm.platform_name}}),_vm._v(" "),(_vm.showBankSelect)?_c('popup-radio',{attrs:{"title":("" + (_vm.$t('bank'))),"options":_vm.banks},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(props.label))])]}}],null,false,1357084177),model:{value:(_vm.bank_id),callback:function ($$v) {_vm.bank_id=$$v},expression:"bank_id"}}):_vm._e(),_vm._v(" "),(_vm.showname)?_c('x-input',{attrs:{"title":((_vm.$t('name')) + "："),"placeholder":_vm.$t('enterCardOwnerName'),"type":"text"},model:{value:(_vm.yourname),callback:function ($$v) {_vm.yourname=$$v},expression:"yourname"}}):_vm._e(),_vm._v(" "),_c('DynamicInput',{attrs:{"fields":_vm.custom_fields,"formData":_vm.custom,"errors":_vm.custom_errors},on:{"update:formData":function($event){_vm.custom=$event},"update:form-data":function($event){_vm.custom=$event},"update:errors":function($event){_vm.custom_errors=$event}}}),_vm._v(" "),(_vm.showmobile)?_c('x-input',{attrs:{"title":((_vm.$t('phoneNumber')) + "："),"placeholder":("" + (_vm.$t('mobilePlaceholder'))),"type":"text"},model:{value:(_vm.mobileno),callback:function ($$v) {_vm.mobileno=$$v},expression:"mobileno"}}):_vm._e(),_vm._v(" "),(_vm.showAmountInput)?_c('div',[_c('group',{attrs:{"gutter":"0","title":((_vm.$t('lowest')) + " " + (_vm.platform.min_load) + (_vm.platform.symbol) + " " + (_vm.$t('highest')) + " " + (_vm.platform.max_load) + (_vm.platform.symbol))}},[(_vm.show_amount_input)?_c('x-input',{attrs:{"title":((_vm.input_amount * 1) + " " + (_vm.$t('point'))),"type":"tel","placeholder":_vm.$t('enterCustomAmount'),"text-align":"right","max":8},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.amountList},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"width":"100%"}},[_c('label',[_vm._v(_vm._s(props.label)+" "+_vm._s(_vm.$t('point')))]),_vm._v(" "),_c('span',{staticClass:"font-green",staticStyle:{"position":"absolute","left":"70%"}},[_vm._v(_vm._s(_vm.platform.symbol)+_vm._s(props.label))])])]}}],null,false,3127527474),model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)],1):_c('x-input',{attrs:{"title":((_vm.$t('payAmount')) + "："),"disabled":true,"value":_vm.show_amount}}),_vm._v(" "),_c('box',{attrs:{"gap":"25px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('payImmediately')))]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"30px","text-align":"left"}},[_c('p',[_c('i',[_vm._v(_vm._s(_vm.platform.description))])])])],1)],1),_vm._v(" "),_c('popup',{model:{value:(_vm.showPlatform),callback:function ($$v) {_vm.showPlatform=$$v},expression:"showPlatform"}},[_c('div',[_c('x-header',{staticClass:"vux-popup-header",attrs:{"slot":"header","title":"","left-options":{showBack: false}},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.$t('choosePaymentMethod')))]),_vm._v(" "),_c('a',{staticStyle:{"font-size":"1.5em"},attrs:{"slot":"right","type":"close"},on:{"click":function($event){_vm.showPlatform = false}},slot:"right"},[_vm._v("✕")])]),_vm._v(" "),_c('group',{attrs:{"gutter":"0"}},[_c('radio',{attrs:{"options":_vm.platforms},on:{"click":function($event){_vm.showPlatform = false},"on-change":_vm.changePlatform},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"45px"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"float":"left","margin-right":"10px"},attrs:{"width":"45","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","line-height":"20px"}},[_vm._v(_vm._s(props.label)+"\n                    "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999999","clear":"both","text-align":"center","line-height":"20px"}},[_vm._v(_vm._s(_vm.platforms[props.index].min_load)+"-"+_vm._s(_vm.platforms[props.index].max_load)+_vm._s(_vm.platforms[props.index].symbol)+"\n                    "),(_vm.platforms[props.index].succ_percent !== 0)?_c('span',[_vm._v("\n                      "+_vm._s(_vm.$t('have'))+" "),_c('span',{staticStyle:{"color":"#f00"}},[_vm._v(_vm._s(_vm.platforms[props.index].succ_percent))]),_vm._v(" "+_vm._s(_vm.$t('personSuccess')))]):_vm._e()])])])]}}]),model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}})],1)],1)]),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":("" + (_vm.$t('done'))),"type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© CC")])],1)],2),_vm._v(" "),(_vm.showload)?_c('div',{staticClass:"loadcon"},[_vm._m(0)]):_vm._e()],1)}
var Deposit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxcon"},[_c('img',{attrs:{"src":__webpack_require__("4cF/"),"alt":"","srcset":""}})])}]
var Deposit_esExports = { render: Deposit_render, staticRenderFns: Deposit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit = (Deposit_esExports);
// CONCATENATED MODULE: ./src/components/Deposit.vue
function Deposit_injectStyle (ssrContext) {
  __webpack_require__("fzG1")
}
var Deposit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit___vue_template_functional__ = false
/* styles */
var Deposit___vue_styles__ = Deposit_injectStyle
/* scopeId */
var Deposit___vue_scopeId__ = "data-v-0f0e2264"
/* moduleIdentifier (server only) */
var Deposit___vue_module_identifier__ = null
var Deposit_Component = Deposit_normalizeComponent(
  components_Deposit,
  selectortype_template_index_0_src_components_Deposit,
  Deposit___vue_template_functional__,
  Deposit___vue_styles__,
  Deposit___vue_scopeId__,
  Deposit___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit = (Deposit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5beda2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("9mUp")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1942c497","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("XeZn")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit1.vue


















/* harmony default export */ var Deposit1 = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  data: function data() {
    return {
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: ''
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      if (typeof platforms.platform_id !== 'undefined' && platforms.platform_id !== null) {
        self.platform_name = platforms.platform.name;
        self.showChoosePlatform = false;
        self.platform_key = platforms.platform.platform_id;

        if (platforms.platform.need_bank === 1 && platforms.platform.bank_id === '') {
          self.showBankSelect = true;
          var banks = [];
          for (var id in platforms.platform.banks) {
            var val = platforms.platform.banks[id];
            banks = banks.concat([{
              key: id,
              value: val.name
            }]);
          }
          self.banks = banks;
        }
        var platform = platforms.platforms[0];
        self.platforms = self.platforms.concat({
          key: platform.id,
          value: platform.name,
          need_bank: platform.need_bank,
          bank_id: platform.bank_id,
          max_load: platform.max_load,
          min_load: platform.min_load,
          icon: 'static/images/logo/' + platform.icon + '.png',
          show: platform.hasOwnProperty('show') ? {
            content: platform.show.content,
            type: platform.show.type,
            link: platform.show[platform.show.type]
          } : null,
          banks: platform.banks,
          need_name: platform.need_name,
          need_mobile: platform.need_mobile
        });
        self.platforms_hash[platforms.platform.platform_id] = platforms.platform;
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _platform = _step.value;

            var mobileShow, mobileDefault;
            if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
              if (navigator.userAgent.indexOf('Android') > -1) {
                mobileShow = _platform.android_show;
                mobileDefault = _platform.android_default;
              } else {
                mobileShow = _platform.ios_show;
                mobileDefault = _platform.ios_default;
              }
            } else {
              mobileShow = _platform.pc_show;
              mobileDefault = _platform.pc_default;
            }
            var platformObj = {
              show_view: Boolean(mobileShow),
              default_show: Boolean(mobileDefault),
              key: _platform.id,
              value: _platform.name,
              description: _platform.description,
              need_bank: _platform.need_bank,
              bank_id: _platform.bank_id,
              max_load: _platform.max_load,
              min_load: _platform.min_load,
              icon: 'static/images/logo/' + _platform.icon + '.png',
              show: _platform.hasOwnProperty('show') ? {
                content: _platform.show.content,
                type: _platform.show.type,
                link: _platform.show[_platform.show.type]
              } : null,
              banks: _platform.banks,
              amount_list: _platform.custom_amounts,
              static_amount: _platform.static_amount,
              succ_percent: _platform.succ_percent,
              need_name: _platform.need_name,
              need_mobile: _platform.need_mobile
            };
            if (platformObj.show_view) {
              self.platforms = self.platforms.concat(platformObj);
            }
            self.platforms_hash[platformObj.key] = platformObj;

            if (platformObj.default_show) {
              self.platform_key = platformObj.key;
              self.platform = platformObj;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (self.platforms.length === 0) {
          self.$router.replace({
            path: '/error',
            query: {
              title: '暂无可用通道',
              description1: '订单：' + platforms.app_order_no,
              description2: '支付类型：' + platforms.type
            }
          });
          return;
        } else if (self.platforms.length === 1) {
          self.platform_key = self.platforms[0].key;
          self.platform_name = self.platforms[0].value;
        } else if (self.platforms.length > 1) {
          self.showChoosePlatform = true;
          self.showPlatform = false;
        }

        self.checkBank();
      }

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.submit(submitAmout);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;

      self.$models.Deposit.create({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit1.vue


















/* harmony default export */ var components_Deposit1 = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  data: function data() {
    return {
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: ''
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      if (typeof platforms.platform_id !== 'undefined' && platforms.platform_id !== null) {
        self.platform_name = platforms.platform.name;
        self.showChoosePlatform = false;
        self.platform_key = platforms.platform.platform_id;

        if (platforms.platform.need_bank === 1 && platforms.platform.bank_id === '') {
          self.showBankSelect = true;
          var banks = [];
          for (var id in platforms.platform.banks) {
            var val = platforms.platform.banks[id];
            banks = banks.concat([{
              key: id,
              value: val.name
            }]);
          }
          self.banks = banks;
        }
        var platform = platforms.platforms[0];
        self.platforms = self.platforms.concat({
          key: platform.id,
          value: platform.name,
          need_bank: platform.need_bank,
          bank_id: platform.bank_id,
          max_load: platform.max_load,
          min_load: platform.min_load,
          icon: 'static/images/logo/' + platform.icon + '.png',
          show: platform.hasOwnProperty('show') ? {
            content: platform.show.content,
            type: platform.show.type,
            link: platform.show[platform.show.type]
          } : null,
          banks: platform.banks,
          need_name: platform.need_name,
          need_mobile: platform.need_mobile
        });
        self.platforms_hash[platforms.platform.platform_id] = platforms.platform;
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _platform = _step.value;

            var mobileShow, mobileDefault;
            if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
              if (navigator.userAgent.indexOf('Android') > -1) {
                mobileShow = _platform.android_show;
                mobileDefault = _platform.android_default;
              } else {
                mobileShow = _platform.ios_show;
                mobileDefault = _platform.ios_default;
              }
            } else {
              mobileShow = _platform.pc_show;
              mobileDefault = _platform.pc_default;
            }
            var platformObj = {
              show_view: Boolean(mobileShow),
              default_show: Boolean(mobileDefault),
              key: _platform.id,
              value: _platform.name,
              description: _platform.description,
              need_bank: _platform.need_bank,
              bank_id: _platform.bank_id,
              max_load: _platform.max_load,
              min_load: _platform.min_load,
              icon: 'static/images/logo/' + _platform.icon + '.png',
              show: _platform.hasOwnProperty('show') ? {
                content: _platform.show.content,
                type: _platform.show.type,
                link: _platform.show[_platform.show.type]
              } : null,
              banks: _platform.banks,
              amount_list: _platform.custom_amounts,
              static_amount: _platform.static_amount,
              succ_percent: _platform.succ_percent,
              need_name: _platform.need_name,
              need_mobile: _platform.need_mobile
            };
            if (platformObj.show_view) {
              self.platforms = self.platforms.concat(platformObj);
            }
            self.platforms_hash[platformObj.key] = platformObj;

            if (platformObj.default_show) {
              self.platform_key = platformObj.key;
              self.platform = platformObj;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (self.platforms.length === 0) {
          self.$router.replace({
            path: '/error',
            query: {
              title: '暂无可用通道',
              description1: '订单：' + platforms.app_order_no,
              description2: '支付类型：' + platforms.type
            }
          });
          return;
        } else if (self.platforms.length === 1) {
          self.platform_key = self.platforms[0].key;
          self.platform_name = self.platforms[0].value;
        } else if (self.platforms.length > 1) {
          self.showChoosePlatform = true;
          self.showPlatform = false;
        }

        self.checkBank();
      }

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.submit(submitAmout);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;

      self.$models.Deposit.create({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6723f19a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit1.vue
var Deposit1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值","left-options":{showBack: false, backText: ''},"right-options":{showMore: false}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('group',{attrs:{"gutter":"10px","title":'订单：' + _vm.app_order_no}},[(_vm.showChoosePlatform)?_c('group',{attrs:{"gutter":"0px","title":"选择付款渠道"}},[_c('checker',{attrs:{"radio-required":true,"default-item-class":"platform-checker-default","selected-item-class":"platform-checker-selected"},on:{"on-change":_vm.changePlatform},model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}},_vm._l((_vm.platforms),function(props){return _c('checker-item',{key:props.key,attrs:{"value":props.key}},[_c('img',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"width":"35","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"height":"14px","overflow":"hidden","display":"inline-block"}},[_vm._v(_vm._s(props.value))])])}),1),_vm._v(" "),_c('radio',{attrs:{"options":_vm.platforms},on:{"click":function($event){_vm.showPlatform = false},"on-change":_vm.changePlatform},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"45px"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"float":"left","margin-right":"10px"},attrs:{"width":"45","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","line-height":"20px"}},[_vm._v(_vm._s(props.label)+"\n                  "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999999","clear":"both","text-align":"center","line-height":"20px"}},[_vm._v(_vm._s(_vm.platforms[props.index].min_load)+"-"+_vm._s(_vm.platforms[props.index].max_load)+"元\n                  "),(_vm.platforms[props.index].succ_percent !== 0)?_c('span',[_vm._v("有"),_c('span',{staticStyle:{"color":"#f00"}},[_vm._v(_vm._s(_vm.platforms[props.index].succ_percent))]),_vm._v("的人成功充值")]):_vm._e()])])])]}}],null,false,2269483834),model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}})],1):_c('x-input',{attrs:{"title":"付款方式：","disabled":true,"value":_vm.platform_name}}),_vm._v(" "),_c('group',{attrs:{"gutter":"0px"}},[(_vm.showBankSelect)?_c('popup-radio',{attrs:{"title":"银行","options":_vm.banks},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(props.label))])]}}],null,false,1357084177),model:{value:(_vm.bank_id),callback:function ($$v) {_vm.bank_id=$$v},expression:"bank_id"}}):_vm._e(),_vm._v(" "),(_vm.showname)?_c('x-input',{attrs:{"title":"名字：","placeholder":"输入您付款卡的持卡人姓名","type":"text"},model:{value:(_vm.yourname),callback:function ($$v) {_vm.yourname=$$v},expression:"yourname"}}):_vm._e(),_vm._v(" "),(_vm.showmobile)?_c('x-input',{attrs:{"title":"手机号码：","placeholder":"输入您付款卡对应的手机号","type":"text"},model:{value:(_vm.mobileno),callback:function ($$v) {_vm.mobileno=$$v},expression:"mobileno"}}):_vm._e(),_vm._v(" "),(_vm.showAmountInput)?_c('div',[_c('group',{attrs:{"gutter":"0","title":'最低'+_vm.platform.min_load+'元 最高'+_vm.platform.max_load+'元'}},[(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' 积分',"type":"tel","placeholder":"输入自定义金额","text-align":"right","max":8},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1),_vm._v(" "),_c('group',[_c('radio',{attrs:{"options":_vm.amountList},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"width":"100%"}},[_c('label',[_vm._v(_vm._s(props.label)+" 积分")]),_vm._v(" "),_c('span',{staticClass:"font-green",staticStyle:{"position":"absolute","left":"70%"}},[_vm._v("¥"+_vm._s(props.label))])])]}}],null,false,1870671935),model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)],1):_c('x-input',{attrs:{"title":"付款金额：","disabled":true,"value":_vm.show_amount}}),_vm._v(" "),(_vm.platform_key == 112 || _vm.platform_key == 180)?_c('x-input',{attrs:{"title":"卡号：","type":"text","placeholder":"请输入付款卡卡号"},model:{value:(_vm.bank_card_no),callback:function ($$v) {_vm.bank_card_no=$$v},expression:"bank_card_no"}}):_vm._e(),_vm._v(" "),_c('box',{attrs:{"gap":"25px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("立即支付")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"30px","text-align":"left"}},[(_vm.platform_key==133 || _vm.platform_key==116 || _vm.platform_key==147 || _vm.platform_key==148)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n                  1、在打开页面截屏保存二维码；"),_c('br'),_vm._v("\n                  2、使用任何一家银行，大众点评，京东，美团app扫码即可完成支付；\n                  "),_c('a',{attrs:{"href":'https://billcloud.unionpay.com/upwxs-mktc/web/mapp/wxe990cdbcc189456e/custom/alllist',"target":"_blank"}},[_vm._v("(点击查看支持app列表)")])])]):_vm._e(),_vm._v(" "),(_vm.platform_key==136 || _vm.platform_key==143)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n                  1、使用A手机在打开的页面获取二维码；"),_c('br'),_vm._v("\n                  2、使用B手机，进行微信扫码并完成支付；"),_c('br'),_vm._v("\n                  3、建议直接保存二维码到相册，打开本机微信扫码功能，从相册选择二维码，识别进行支付。"),_c('br')])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('i',[_vm._v(_vm._s(_vm.platform.description))])])])],1)],1)],1),_vm._v(" "),_c('popup',{model:{value:(_vm.showPlatform),callback:function ($$v) {_vm.showPlatform=$$v},expression:"showPlatform"}},[_c('div',[_c('x-header',{staticClass:"vux-popup-header",attrs:{"slot":"header","title":"","left-options":{showBack: false}},slot:"header"},[_c('span',[_vm._v("选择付款方式")]),_vm._v(" "),_c('a',{staticStyle:{"font-size":"1.5em"},attrs:{"slot":"right","type":"close"},on:{"click":function($event){_vm.showPlatform = false}},slot:"right"},[_vm._v("✕")])]),_vm._v(" "),_c('group',{attrs:{"gutter":"0"}},[_c('radio',{attrs:{"options":_vm.platforms},on:{"click":function($event){_vm.showPlatform = false},"on-change":_vm.changePlatform},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"45px"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"float":"left","margin-right":"10px"},attrs:{"width":"45","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","line-height":"20px"}},[_vm._v(_vm._s(props.label)+"\n                    "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999999","clear":"both","text-align":"center","line-height":"20px"}},[_vm._v(_vm._s(_vm.platforms[props.index].min_load)+"-"+_vm._s(_vm.platforms[props.index].max_load)+"元\n                    "),(_vm.platforms[props.index].succ_percent !== 0)?_c('span',[_vm._v("有"),_c('span',{staticStyle:{"color":"#f00"}},[_vm._v(_vm._s(_vm.platforms[props.index].succ_percent))]),_vm._v("的人成功充值")]):_vm._e()])])])]}}]),model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}})],1)],1)]),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© CC")])],1)],2)],1)}
var Deposit1_staticRenderFns = []
var Deposit1_esExports = { render: Deposit1_render, staticRenderFns: Deposit1_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit1 = (Deposit1_esExports);
// CONCATENATED MODULE: ./src/components/Deposit1.vue
function Deposit1_injectStyle (ssrContext) {
  __webpack_require__("X3S4")
}
var Deposit1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit1___vue_template_functional__ = false
/* styles */
var Deposit1___vue_styles__ = Deposit1_injectStyle
/* scopeId */
var Deposit1___vue_scopeId__ = "data-v-6723f19a"
/* moduleIdentifier (server only) */
var Deposit1___vue_module_identifier__ = null
var Deposit1_Component = Deposit1_normalizeComponent(
  components_Deposit1,
  selectortype_template_index_0_src_components_Deposit1,
  Deposit1___vue_template_functional__,
  Deposit1___vue_styles__,
  Deposit1___vue_scopeId__,
  Deposit1___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit1 = (Deposit1_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039300f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("fKba")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c3c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6d97f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("ecYn")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2.vue























/* harmony default export */ var Deposit2 = ({
  components: {
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Confirm: node_modules_vux_src_components_confirm,
    Icon: vux_src_components_icon
  },
  data: function data() {
    return {
      showDialog: false,
      submitAmount: 0,
      loaded: false,
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      need_deduct: false,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      type_id: 1,
      types_map: [],
      platform_type_map: [],
      type1: 0
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info1({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var platform = _step.value;

          var mobileShow, mobileDefault;
          if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
            if (navigator.userAgent.indexOf('Android') > -1) {
              mobileShow = platform.android_show;
              mobileDefault = platform.android_default;
            } else {
              mobileShow = platform.ios_show;
              mobileDefault = platform.ios_default;
            }
          } else {
            mobileShow = platform.pc_show;
            mobileDefault = platform.pc_default;
          }
          var platformObj = {
            show_view: Boolean(mobileShow),
            default_show: Boolean(mobileDefault),
            key: platform.id,
            value: platform.name,
            description: platform.description,
            need_bank: platform.need_bank,
            bank_id: platform.bank_id,
            max_load: platform.max_load,
            min_load: platform.min_load,
            icon: 'static/images/logo/' + platform.icon + '.png',
            show: platform.hasOwnProperty('show') ? {
              content: platform.show.content,
              type: platform.show.type,
              link: platform.show[platform.show.type]
            } : null,
            banks: platform.banks,
            amount_list: platform.custom_amounts,
            static_amount: platform.static_amount,
            succ_percent: platform.succ_percent,
            need_name: platform.need_name,
            need_mobile: platform.need_mobile,
            need_deduct: platform.need_deduct
          };
          if (platformObj.show_view) {
            if (typeof self.platform_type_map[platform.type_id] === 'undefined') self.platform_type_map[platform.type_id] = [];
            self.platform_type_map[platform.type_id] = self.platform_type_map[platform.type_id].concat(platformObj);
          }
          self.platforms_hash[platformObj.key] = platformObj;

          if (platformObj.default_show) {
            self.platform_key = platformObj.key;
            self.platform = platformObj;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.types_map = platforms.types;
      self.swapElement(self.types_map, 0, 1);
      if (sessionStorage.getItem('type_id')) {
        self.type_id = parseInt(sessionStorage.getItem('type_id'));
      } else {
        self.type_id = self.types_map[0]['type_id'];
      }
      self.showChoosePlatform = true;
      self.showPlatform = false;

      self.changeType(self.type_id);

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          if (this.need_deduct) {
            this.submitAmount = submitAmout;
            this.callDialog();
          } else {
            this.submit(submitAmout);
          }
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      self.loaded = true;

      self.$models.Deposit.create1({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        self.loaded = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changeType: function changeType(e) {
      var self = this;
      if (typeof self.platform_type_map[e] === 'undefined') {
        this.$vux.toast.show({
          'text': '暂无可用渠道',
          'type': 'text'
        });
        this.type_id = 0;
      } else {
        self.platforms = self.platform_type_map[e];
        self.platform_key = self.platforms[0].key;
        self.changePlatform(self.platform_key);
        self.checkBank();
      }
      sessionStorage.setItem('type_id', e);
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }

        self.need_deduct = platform.need_deduct;
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    showVIP: function showVIP() {
      this.$vux.toast.show({
        'text': '渠道尚未开放，敬请期待',
        'type': 'text'
      });
      this.type1 = 0;
    },
    swapElement: function swapElement(array, indexA, indexB) {
      var tmp = array[indexA];
      array[indexA] = array[indexB];
      array[indexB] = tmp;
    },
    dynamicDepositTips: function dynamicDepositTips(parent) {
      var _this = this;

      return ((this.platform_type_map[parent.type_id] || []).filter(function (item) {
        return _this.platform_key === item.key;
      })[0] || {}).need_deduct;
    },
    callDialog: function callDialog() {
      var self = this;
      if (self.need_deduct) {
        this.showDialog = true;
      }
    },
    onConfirm: function onConfirm() {
      this.submit(this.submitAmount);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2.vue























/* harmony default export */ var components_Deposit2 = ({
  components: {
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Confirm: node_modules_vux_src_components_confirm,
    Icon: vux_src_components_icon
  },
  data: function data() {
    return {
      showDialog: false,
      submitAmount: 0,
      loaded: false,
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      need_deduct: false,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      type_id: 1,
      types_map: [],
      platform_type_map: [],
      type1: 0
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.checkOrderCounts();
    var self = this;

    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }

    self.$models.Deposit.info1({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var platform = _step.value;

          var mobileShow, mobileDefault;
          if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
            if (navigator.userAgent.indexOf('Android') > -1) {
              mobileShow = platform.android_show;
              mobileDefault = platform.android_default;
            } else {
              mobileShow = platform.ios_show;
              mobileDefault = platform.ios_default;
            }
          } else {
            mobileShow = platform.pc_show;
            mobileDefault = platform.pc_default;
          }
          var platformObj = {
            show_view: Boolean(mobileShow),
            default_show: Boolean(mobileDefault),
            key: platform.id,
            value: platform.name,
            description: platform.description,
            need_bank: platform.need_bank,
            bank_id: platform.bank_id,
            max_load: platform.max_load,
            min_load: platform.min_load,
            icon: 'static/images/logo/' + platform.icon + '.png',
            show: platform.hasOwnProperty('show') ? {
              content: platform.show.content,
              type: platform.show.type,
              link: platform.show[platform.show.type]
            } : null,
            banks: platform.banks,
            amount_list: platform.custom_amounts,
            static_amount: platform.static_amount,
            succ_percent: platform.succ_percent,
            need_name: platform.need_name,
            need_mobile: platform.need_mobile,
            need_deduct: platform.need_deduct
          };
          if (platformObj.show_view) {
            if (typeof self.platform_type_map[platform.type_id] === 'undefined') self.platform_type_map[platform.type_id] = [];
            self.platform_type_map[platform.type_id] = self.platform_type_map[platform.type_id].concat(platformObj);
          }
          self.platforms_hash[platformObj.key] = platformObj;

          if (platformObj.default_show) {
            self.platform_key = platformObj.key;
            self.platform = platformObj;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.types_map = platforms.types;
      self.swapElement(self.types_map, 0, 1);
      if (sessionStorage.getItem('type_id')) {
        self.type_id = parseInt(sessionStorage.getItem('type_id'));
      } else {
        self.type_id = self.types_map[0]['type_id'];
      }
      self.showChoosePlatform = true;
      self.showPlatform = false;

      self.changeType(self.type_id);

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          if (this.need_deduct) {
            this.submitAmount = submitAmout;
            this.callDialog();
          } else {
            this.submit(submitAmout);
          }
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      self.loaded = true;

      self.$models.Deposit.create1({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        self.loaded = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changeType: function changeType(e) {
      var self = this;
      if (typeof self.platform_type_map[e] === 'undefined') {
        this.$vux.toast.show({
          'text': '暂无可用渠道',
          'type': 'text'
        });
        this.type_id = 0;
      } else {
        self.platforms = self.platform_type_map[e];
        self.platform_key = self.platforms[0].key;
        self.changePlatform(self.platform_key);
        self.checkBank();
      }
      sessionStorage.setItem('type_id', e);
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }

        self.need_deduct = platform.need_deduct;
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    showVIP: function showVIP() {
      this.$vux.toast.show({
        'text': '渠道尚未开放，敬请期待',
        'type': 'text'
      });
      this.type1 = 0;
    },
    swapElement: function swapElement(array, indexA, indexB) {
      var tmp = array[indexA];
      array[indexA] = array[indexB];
      array[indexB] = tmp;
    },
    dynamicDepositTips: function dynamicDepositTips(parent) {
      var _this = this;

      return ((this.platform_type_map[parent.type_id] || []).filter(function (item) {
        return _this.platform_key === item.key;
      })[0] || {}).need_deduct;
    },
    callDialog: function callDialog() {
      var self = this;
      if (self.need_deduct) {
        this.showDialog = true;
      }
    },
    onConfirm: function onConfirm() {
      this.submit(this.submitAmount);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7554734a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit2.vue
var Deposit2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"0px","body-padding-bottom":"51px"}},[_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}]}),_vm._v(" "),_c('group',{attrs:{"gutter":"10px","title":'订单：' + _vm.app_order_no}},[(_vm.showChoosePlatform)?_c('group',{attrs:{"gutter":"0px"}},[_c('checker',{attrs:{"radio-required":true,"default-item-class":"platform-checker-default","selected-item-class":"platform-checker-selected"},on:{"on-change":_vm.changeType},model:{value:(_vm.type_id),callback:function ($$v) {_vm.type_id=$$v},expression:"type_id"}},_vm._l((_vm.types_map),function(props){return _c('checker-item',{key:props.type_id,staticClass:"bank-icons-opt",attrs:{"value":props.type_id}},[([1, 20].includes(props.type_id))?_c('div',{staticClass:"corner-ribbon"},[_vm._v("推荐")]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"width":"35","src":"static/images/logo/" + props.icon + ".png"}}),_vm._v(" "),_c('span',{staticStyle:{"height":"14px","overflow":"hidden","display":"inline-block"}},[_vm._v(_vm._s(props.type_name))]),_vm._v(" "),(props.type_id === 20)?_c('span',{staticClass:"icon-sub-text"},[_vm._v("充值加送2%")]):_vm._e(),_vm._v(" "),(_vm.dynamicDepositTips(props))?_c('span',{staticClass:"icon-sub-text"},[_vm._v("充值收费10%")]):_vm._e()])}),1),_vm._v(" "),(_vm.type_id == 20)?_c('div',{staticClass:"guide-cont"},[_c('h4',[_vm._v("数字货币  极速到账")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"con"},[_vm._v("\n                交易所购买USDT\n              ")]),_vm._v(" "),_c('div',{staticClass:"con"},[_vm._v("\n                提交存款\n              ")]),_vm._v(" "),_c('div',{staticClass:"con"},[_vm._v("\n                交易所转出USDT\n              ")]),_vm._v(" "),_c('div',{staticClass:"con"},[_vm._v("\n                完成充值\n              ")])]),_vm._v(" "),_c('div',{staticClass:"to-guide"},[_c('a',{attrs:{"href":"/usdt5"}},[_c('span',[_vm._v("了解虚拟币 "),_c('div',{staticClass:"arrow green"})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.otc365.com/"}},[_c('span',[_vm._v("交易所推荐 "),_c('div',{staticClass:"arrow blue"})])])])]):_vm._e(),_vm._v(" "),(_vm.type_id > 0)?_c('group',[_c('radio',{attrs:{"options":_vm.platforms},on:{"on-change":_vm.changePlatform},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"45px"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"float":"left","margin-right":"10px"},attrs:{"width":"45","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","line-height":"20px"}},[_vm._v(_vm._s(props.label)+"\n                    "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999999","clear":"both","text-align":"center","line-height":"20px"}},[_vm._v(_vm._s(_vm.platforms[props.index].min_load)+"-"+_vm._s(_vm.platforms[props.index].max_load)+"元\n                    "),(_vm.platforms[props.index].succ_percent !== 0)?_c('span',[_vm._v("有"),_c('span',{staticStyle:{"color":"#f00"}},[_vm._v(_vm._s(_vm.platforms[props.index].succ_percent))]),_vm._v("的人成功充值")]):_vm._e()])])])]}}],null,false,3907545146),model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}})],1):_vm._e()],1):_c('x-input',{attrs:{"title":"付款方式：","disabled":true,"value":_vm.platform_name}}),_vm._v(" "),(_vm.type_id > 0)?_c('group',{attrs:{"gutter":"0px"}},[(_vm.showAmountInput)?_c('div',[_c('group',{attrs:{"gutter":"0","title":'最低'+_vm.platform.min_load+'元 最高'+_vm.platform.max_load+'元'}},[_c('checker',{attrs:{"radio-required":true,"default-item-class":"amount-checker-default","selected-item-class":"amount-checker-selected"},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},_vm._l((_vm.amountList),function(i){return _c('checker-item',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])}),1),_vm._v(" "),(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' 积分',"type":"tel","placeholder":"输入自定义金额","text-align":"right","max":8},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1)],1):_c('x-input',{attrs:{"title":"付款金额：","disabled":true,"value":_vm.show_amount}}),_vm._v(" "),_c('group',[(_vm.showBankSelect)?_c('popup-radio',{attrs:{"title":"银行","options":_vm.banks},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(props.label))])]}}],null,false,1357084177),model:{value:(_vm.bank_id),callback:function ($$v) {_vm.bank_id=$$v},expression:"bank_id"}}):_vm._e(),_vm._v(" "),(_vm.showname)?_c('x-input',{attrs:{"title":"名字：","placeholder":"输入您付款卡的持卡人姓名","type":"text"},model:{value:(_vm.yourname),callback:function ($$v) {_vm.yourname=$$v},expression:"yourname"}}):_vm._e(),_vm._v(" "),(_vm.showmobile)?_c('x-input',{attrs:{"title":"手机号码：","placeholder":"输入您付款卡对应的手机号","type":"text"},model:{value:(_vm.mobileno),callback:function ($$v) {_vm.mobileno=$$v},expression:"mobileno"}}):_vm._e()],1),_vm._v(" "),_c('box',{attrs:{"gap":"25px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("立即支付 ¥"+_vm._s(Math.max(_vm.amount, _vm.input_amount) ? Math.max(_vm.amount, _vm.input_amount) : 0))]),_vm._v(" "),(_vm.type_id == 1)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/bankcard'}}},[_vm._v("充值/查询/转账教程")]):_vm._e(),_vm._v(" "),(_vm.type_id == 3)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/alipay'}}},[_vm._v("充值/查询/转账教程")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"30px","text-align":"left"}},[_c('br'),_vm._v(" "),_c('p',[_c('i',[_vm._v(_vm._s(_vm.platform.description))])]),_vm._v(" "),(_vm.platform.need_deduct)?_c('div',{staticStyle:{"margin-top":"12px"}},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("温馨提示：")]),_vm._v(" "),_c('p',[_vm._v("该充值方式会从充值金额中扣除10%手续费，请谨慎发起。如介意，建议使用其他渠道充值，不会产生额外手续费。")])]):_vm._e()])],1)],1):_vm._e()],1),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© CC")])],1)],2),_vm._v(" "),_c('div',[_c('confirm',{staticClass:"tips",attrs:{"confirm-text":"继续支付","cancel-text":"取消支付"},on:{"on-confirm":_vm.onConfirm},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('icon',{attrs:{"type":"warn","is-msg":""}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_vm._v("\n          本次充值将产生 "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("10%")]),_vm._v(" 手续费\n        ")])],1)],1)],1)}
var Deposit2_staticRenderFns = []
var Deposit2_esExports = { render: Deposit2_render, staticRenderFns: Deposit2_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit2 = (Deposit2_esExports);
// CONCATENATED MODULE: ./src/components/Deposit2.vue
function Deposit2_injectStyle (ssrContext) {
  __webpack_require__("FuAT")
}
var Deposit2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit2___vue_template_functional__ = false
/* styles */
var Deposit2___vue_styles__ = Deposit2_injectStyle
/* scopeId */
var Deposit2___vue_scopeId__ = "data-v-7554734a"
/* moduleIdentifier (server only) */
var Deposit2___vue_module_identifier__ = null
var Deposit2_Component = Deposit2_normalizeComponent(
  components_Deposit2,
  selectortype_template_index_0_src_components_Deposit2,
  Deposit2___vue_template_functional__,
  Deposit2___vue_styles__,
  Deposit2___vue_scopeId__,
  Deposit2___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit2 = (Deposit2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit3.vue





















/* harmony default export */ var Deposit3 = ({
  components: {
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      theme: ['L', ''],
      currentTheme: 0,
      loaded: false,
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      type_id: 1,
      types_map: [],
      platform_type_map: [],
      type1: 0
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.currentTheme = sessionStorage.getItem('theme');
    this.checkOrderCounts();
    var self = this;
    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }
    self.$models.Deposit.info1({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var platform = _step.value;

          var mobileShow, mobileDefault;
          if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
            if (navigator.userAgent.indexOf('Android') > -1) {
              mobileShow = platform.android_show;
              mobileDefault = platform.android_default;
            } else {
              mobileShow = platform.ios_show;
              mobileDefault = platform.ios_default;
            }
          } else {
            mobileShow = platform.pc_show;
            mobileDefault = platform.pc_default;
          }
          var platformObj = {
            show_view: Boolean(mobileShow),
            default_show: Boolean(mobileDefault),
            key: platform.id,
            value: platform.name,
            description: platform.description,
            need_bank: platform.need_bank,
            bank_id: platform.bank_id,
            max_load: platform.max_load,
            min_load: platform.min_load,
            icon: 'static/images/logo/' + platform.icon + '.png',
            show: platform.hasOwnProperty('show') ? {
              content: platform.show.content,
              type: platform.show.type,
              link: platform.show[platform.show.type]
            } : null,
            banks: platform.banks,
            amount_list: platform.custom_amounts,
            static_amount: platform.static_amount,
            succ_percent: platform.succ_percent,
            need_name: platform.need_name,
            need_mobile: platform.need_mobile
          };
          if (platformObj.show_view) {
            if (typeof self.platform_type_map[platform.type_id] === 'undefined') self.platform_type_map[platform.type_id] = [];
            self.platform_type_map[platform.type_id] = self.platform_type_map[platform.type_id].concat(platformObj);
          }
          self.platforms_hash[platformObj.key] = platformObj;

          if (platformObj.default_show) {
            self.platform_key = platformObj.key;
            self.platform = platformObj;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.types_map = platforms.types;
      if (sessionStorage.getItem('type_id')) {
        self.type_id = parseInt(sessionStorage.getItem('type_id'));
      } else {
        self.type_id = self.types_map[0]['type_id'];
      }
      self.showChoosePlatform = true;
      self.showPlatform = false;

      self.changeType(self.type_id);

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    switchTheme: function switchTheme() {
      if (this.currentTheme === 1) {
        this.currentTheme = 0;
      } else {
        this.currentTheme = 1;
      }
      sessionStorage.setItem('theme', this.currentTheme);
      if (this.currentTheme === 0) {
        document.body.classList.add('light');
        document.body.classList.remove('dark');
      } else {
        document.body.classList.add('dark');
        document.body.classList.remove('light');
      }
    },
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.submit(submitAmout);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      self.loaded = true;

      self.$models.Deposit.create1({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        self.loaded = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changeType: function changeType(e) {
      var self = this;
      if (typeof self.platform_type_map[e] === 'undefined') {
        this.$vux.toast.show({
          'text': '暂无可用渠道',
          'type': 'text'
        });
        this.type_id = 0;
      } else {
        self.platforms = self.platform_type_map[e];
        self.platform_key = self.platforms[0].key;
        self.changePlatform(self.platform_key);
        self.checkBank();
      }
      sessionStorage.setItem('type_id', e);
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    showVIP: function showVIP() {
      this.$vux.toast.show({
        'text': '渠道尚未开放，敬请期待',
        'type': 'text'
      });
      this.type1 = 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit3.vue





















/* harmony default export */ var components_Deposit3 = ({
  components: {
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  data: function data() {
    return {
      theme: ['L', ''],
      currentTheme: 0,
      loaded: false,
      title: '充值',
      showPlatform: false,
      platforms: [],
      platform: {
        value: '',
        icon: '',
        min_load: '',
        max_load: ''
      },
      platforms_hash: [],
      platform_key: null,
      platform_show: {
        desc: ''
      },
      amountList: [],
      defaultAmountList: [100, 200, 500, 1000],
      wechatAmountList: [108, 218, 588, 1098],
      qqAmountList: [100, 218, 318, 500],
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showBankSelect: false,
      banks: [],
      need_bank: null,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      showChoosePlatform: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      showname: false,
      showmobile: false,
      need_name: null,
      need_mobile: null,
      yourname: '',
      mobileno: '',
      type_id: 1,
      types_map: [],
      platform_type_map: [],
      type1: 0
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.currentTheme = sessionStorage.getItem('theme');
    this.checkOrderCounts();
    var self = this;
    if (typeof self.$route.query.platform_id === 'undefined') {
      self.platform_key = 1;
    } else {
      self.platform_key = JSON.parse(self.$route.query.platform_id);
    }
    self.$models.Deposit.info1({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (platforms) {
      platforms = platforms.data.data;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(platforms.platforms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var platform = _step.value;

          var mobileShow, mobileDefault;
          if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/) !== null) {
            if (navigator.userAgent.indexOf('Android') > -1) {
              mobileShow = platform.android_show;
              mobileDefault = platform.android_default;
            } else {
              mobileShow = platform.ios_show;
              mobileDefault = platform.ios_default;
            }
          } else {
            mobileShow = platform.pc_show;
            mobileDefault = platform.pc_default;
          }
          var platformObj = {
            show_view: Boolean(mobileShow),
            default_show: Boolean(mobileDefault),
            key: platform.id,
            value: platform.name,
            description: platform.description,
            need_bank: platform.need_bank,
            bank_id: platform.bank_id,
            max_load: platform.max_load,
            min_load: platform.min_load,
            icon: 'static/images/logo/' + platform.icon + '.png',
            show: platform.hasOwnProperty('show') ? {
              content: platform.show.content,
              type: platform.show.type,
              link: platform.show[platform.show.type]
            } : null,
            banks: platform.banks,
            amount_list: platform.custom_amounts,
            static_amount: platform.static_amount,
            succ_percent: platform.succ_percent,
            need_name: platform.need_name,
            need_mobile: platform.need_mobile
          };
          if (platformObj.show_view) {
            if (typeof self.platform_type_map[platform.type_id] === 'undefined') self.platform_type_map[platform.type_id] = [];
            self.platform_type_map[platform.type_id] = self.platform_type_map[platform.type_id].concat(platformObj);
          }
          self.platforms_hash[platformObj.key] = platformObj;

          if (platformObj.default_show) {
            self.platform_key = platformObj.key;
            self.platform = platformObj;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      self.types_map = platforms.types;
      if (sessionStorage.getItem('type_id')) {
        self.type_id = parseInt(sessionStorage.getItem('type_id'));
      } else {
        self.type_id = self.types_map[0]['type_id'];
      }
      self.showChoosePlatform = true;
      self.showPlatform = false;

      self.changeType(self.type_id);

      if (platforms.amount === null || platforms.amount === '' || platforms.amount === '0.00') {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = platforms.amount;
      }

      self.app_order_no = platforms.app_order_no;
      self.yourname = platforms.username;

      if (!(self.showChoosePlatform === true || self.showBankSelect === true || self.showAmountInput === true || self.platform_key === 88 || self.platform_key === 112 || self.platform_key === 180)) {
        self.check();
      }
    });
  },

  methods: {
    switchTheme: function switchTheme() {
      if (this.currentTheme === 1) {
        this.currentTheme = 0;
      } else {
        this.currentTheme = 1;
      }
      sessionStorage.setItem('theme', this.currentTheme);
      if (this.currentTheme === 0) {
        document.body.classList.add('light');
        document.body.classList.remove('dark');
      } else {
        document.body.classList.add('dark');
        document.body.classList.remove('light');
      }
    },
    checkBank: function checkBank() {
      this.showBankSelect = false;
      this.banks = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.platforms), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var platform = _step2.value;

          if (platform.key === this.platform_key && platform.need_bank === 1) {
            this.bank_id = platform.bank_id;
            if (platform.bank_id === '') {
              this.showBankSelect = true;
              var banks = [];
              for (var id in platform.banks) {
                var val = platform.banks[id];
                banks = banks.concat([{
                  key: id,
                  value: val.name
                }]);
              }
              this.banks = banks;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    check: function check() {
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.platforms_hash[this.platform_key].min_load;
      var maxLoad = this.platforms_hash[this.platform_key].max_load;
      var needname = this.platforms_hash[this.platform_key].need_name;
      var needmobile = this.platforms_hash[this.platform_key].need_mobile;
      if (this.platform_key === 88 && this.name === '') {
        this.$vux.toast.show({
          'text': '请输入付款银行卡姓名！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 112 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (this.platform_key === 180 && this.bank_card_no === '') {
        this.$vux.toast.show({
          'text': '请输入付款卡卡号！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname === '') {
        this.$vux.toast.show({
          'text': '请输入您的真实姓名！',
          'type': 'warn'
        });
        return;
      }
      if (needname === 1 && this.yourname !== '') {
        cookie["a" /* default */].set('yourname', this.yourname, {
          expires: 86400 * 30
        });
      }
      if (needmobile === 1 && this.mobileno === '') {
        this.$vux.toast.show({
          'text': '请输入您的手机号码！',
          'type': 'warn'
        });
        return;
      }
      if (needmobile === 1 && this.mobileno !== '') {
        cookie["a" /* default */].set('mobileno', this.mobileno, {
          expires: 86400 * 30
        });
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        if (submitAmout % 1 === 0) {
          this.submit(submitAmout);
        } else {
          this.$vux.toast.show({
            'text': '请输入整数',
            'type': 'warn'
          });
        }
      } else {
        var name = this.platforms_hash[this.platform_key].value;
        this.$vux.alert.show({
          content: name + '充值支持 ' + minLoad + '元 ~ ' + maxLoad + '元'
        });
      }
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      self.loaded = true;

      self.$models.Deposit.create1({
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.platform_key,
        bank_id: self.bank_id,
        bank_name: self.name,
        amount: submitAmout,
        bank_card_no: self.bank_card_no,
        name: self.yourname,
        mobile: self.mobileno
      }).then(function (response) {
        self.pay_click = false;
        self.loaded = false;
        if (!response.data.success) {
          self.$vux.toast.show({
            'text': response.data.message,
            'type': 'warn'
          });

          return;
        }

        cookie["a" /* default */].remove('historys');

        self.load_url = response.data.data.load_url;

        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          self.showAsk();
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.platform_key,
              from_url: self.$route.path
            }
          });
          return;
        }

        self.showPayPage = true;

        self.$vux.loading.show({
          text: 'Loading'
        });
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 3000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: '请在新开窗口中完成支付<br />若已完成，请点击“完成支付"',
        confirmText: '完成支付',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    changeType: function changeType(e) {
      var self = this;
      if (typeof self.platform_type_map[e] === 'undefined') {
        this.$vux.toast.show({
          'text': '暂无可用渠道',
          'type': 'text'
        });
        this.type_id = 0;
      } else {
        self.platforms = self.platform_type_map[e];
        self.platform_key = self.platforms[0].key;
        self.changePlatform(self.platform_key);
        self.checkBank();
      }
      sessionStorage.setItem('type_id', e);
    },
    changePlatform: function changePlatform(e) {
      var self = this;
      if (self.platforms_hash.hasOwnProperty(e)) {
        var platform = self.platforms_hash[e];
        self.platform = platform;
        if (self.platform.key === 12) {
          self.amountList = self.qqAmountList;
        } else {
          self.amountList = platform.amount_list == null ? self.defaultAmountList : platform.amount_list;
        }
        self.show_amount_input = platform.static_amount === 0;
        if (self.amount_index === -1) {
          self.amount_index = 0;
        }
        self.amount = self.amountList[self.amount_index];
        self.showContent(self.platform);
        if (platform.need_name === 1) {
          self.showname = true;
          if (typeof cookie["a" /* default */].get('yourname') === 'string') {
            self.yourname = cookie["a" /* default */].get('yourname');
          }
          console.log(cookie["a" /* default */].get('yourname'));
        } else {
          self.showname = false;
          self.yourname = self.getUserName();
        }
        if (platform.need_mobile === 1) {
          self.showmobile = true;
          if (typeof cookie["a" /* default */].get('mobileno') === 'string') {
            self.mobileno = cookie["a" /* default */].get('mobileno');
          }
        } else {
          self.showmobile = false;
          self.mobileno = '';
        }
      }
      self.showPlatform = false;
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: '订单发起过于频繁',
              description1: '对不起，因您频繁发起订单但未提交支付',
              description2: '请您休息五分钟再尝试，谢谢您的配合'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },
    getUserName: function getUserName() {
      return this.yourname.length ? this.yourname : '';
    },
    showVIP: function showVIP() {
      this.$vux.toast.show({
        'text': '渠道尚未开放，敬请期待',
        'type': 'text'
      });
      this.type1 = 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22575594","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit3.vue
var Deposit3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add",class:_vm.currentTheme == 1 ? 'dark':'light',staticStyle:{"height":"100%"}},[_c('div',{staticClass:"header-bg"}),_vm._v(" "),_c('view-box',{attrs:{"body-padding-top":"0px","body-padding-bottom":"51px"}},[_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}]}),_vm._v(" "),_c('div',{staticClass:"theme"},[_c('div',{staticClass:"switch",on:{"click":function($event){return _vm.switchTheme()}}},[_c('div',{staticClass:"round"})])]),_vm._v(" "),_c('group',{staticClass:"platform-choices",attrs:{"gutter":"10px","title":'订单：' + _vm.app_order_no}},[(_vm.showChoosePlatform)?_c('group',{attrs:{"gutter":"0px"}},[_c('checker',{attrs:{"radio-required":true,"default-item-class":"platform-checker-default","selected-item-class":"platform-checker-selected"},on:{"on-change":_vm.changeType},model:{value:(_vm.type_id),callback:function ($$v) {_vm.type_id=$$v},expression:"type_id"}},_vm._l((_vm.types_map),function(props){return _c('checker-item',{key:props.type_id,attrs:{"value":props.type_id}},[(props.type_id == 1 || props.type_id == 20)?_c('div',{staticClass:"corner-ribbon"},[_vm._v("推荐")]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"width":"35","src":"static/images/logo/" + props.icon + ".png"}}),_vm._v(" "),_c('span',{staticStyle:{"height":"14px","overflow":"hidden","display":"inline-block"}},[_vm._v(_vm._s(props.type_name))])])}),1),_vm._v(" "),(_vm.type_id > 0)?_c('group',[_c('radio',{attrs:{"options":_vm.platforms},on:{"on-change":_vm.changePlatform},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"45px"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"float":"left","margin-right":"10px"},attrs:{"width":"45","src":props.icon}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","line-height":"20px"}},[_vm._v(_vm._s(props.label)+"\n                    "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999999","clear":"both","text-align":"center","line-height":"20px"}},[_vm._v(_vm._s(_vm.platforms[props.index].min_load)+"-"+_vm._s(_vm.platforms[props.index].max_load)+"元\n                    "),(_vm.platforms[props.index].succ_percent !== 0)?_c('span',[_vm._v("有"),_c('span',{staticStyle:{"color":"#f00"}},[_vm._v(_vm._s(_vm.platforms[props.index].succ_percent))]),_vm._v("的人成功充值")]):_vm._e()])])])]}}],null,false,3907545146),model:{value:(_vm.platform_key),callback:function ($$v) {_vm.platform_key=$$v},expression:"platform_key"}})],1):_vm._e()],1):_c('x-input',{attrs:{"title":"付款方式：","disabled":true,"value":_vm.platform_name}}),_vm._v(" "),(_vm.type_id > 0)?_c('group',{attrs:{"gutter":"0px"}},[(_vm.showAmountInput)?_c('div',[_c('group',{staticClass:"amount-choice",attrs:{"gutter":"0","title":'最低'+_vm.platform.min_load+'元 最高'+_vm.platform.max_load+'元'}},[_c('checker',{attrs:{"radio-required":true,"default-item-class":"amount-checker-default","selected-item-class":"amount-checker-selected"},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}},_vm._l((_vm.amountList),function(i){return _c('checker-item',{key:i,attrs:{"value":i}},[_vm._v(_vm._s(i))])}),1),_vm._v(" "),(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' 积分',"type":"tel","placeholder":"输入自定义金额","text-align":"right","max":8},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1)],1):_c('x-input',{attrs:{"title":"付款金额：","disabled":true,"value":_vm.show_amount}}),_vm._v(" "),_c('group',[(_vm.showBankSelect)?_c('popup-radio',{attrs:{"title":"银行","options":_vm.banks},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"20px"}},[_vm._v(_vm._s(props.label))])]}}],null,false,1357084177),model:{value:(_vm.bank_id),callback:function ($$v) {_vm.bank_id=$$v},expression:"bank_id"}}):_vm._e(),_vm._v(" "),(_vm.showname)?_c('x-input',{attrs:{"title":"名字：","placeholder":"输入您付款卡的持卡人姓名","type":"text"},model:{value:(_vm.yourname),callback:function ($$v) {_vm.yourname=$$v},expression:"yourname"}}):_vm._e(),_vm._v(" "),(_vm.showmobile)?_c('x-input',{attrs:{"title":"手机号码：","placeholder":"输入您付款卡对应的手机号","type":"text"},model:{value:(_vm.mobileno),callback:function ($$v) {_vm.mobileno=$$v},expression:"mobileno"}}):_vm._e()],1),_vm._v(" "),_c('box',{staticClass:"btn-grp",attrs:{"gap":"25px 15px"}},[_c('x-button',{staticClass:"submit-btn",attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("立即支付 ¥"+_vm._s(Math.max(_vm.amount, _vm.input_amount) ? Math.max(_vm.amount, _vm.input_amount) : 0))]),_vm._v(" "),(_vm.type_id == 1)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/bankcard'}}},[_vm._v("充值/查询/转账教程")]):_vm._e(),_vm._v(" "),(_vm.type_id == 3)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/alipay'}}},[_vm._v("充值/查询/转账教程")]):_vm._e(),_vm._v(" "),(_vm.type_id == 20)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/usdt4'}}},[_vm._v("如何获得USDT ERC20")]):_vm._e(),_vm._v(" "),(_vm.type_id == 20)?_c('x-button',{staticStyle:{"border":"2px solid rgb(0, 145, 255)","background":"#fff","color":"rgb(0, 145, 255)"},attrs:{"link":{'path': '/usdt3'}}},[_vm._v("充值教程")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"30px","text-align":"left"}},[_c('p',{staticClass:"desc"},[_c('i',[_vm._v(_vm._s(_vm.platform.description))])])])],1)],1):_vm._e()],1),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© CC")])],1)],2)],1)}
var Deposit3_staticRenderFns = []
var Deposit3_esExports = { render: Deposit3_render, staticRenderFns: Deposit3_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit3 = (Deposit3_esExports);
// CONCATENATED MODULE: ./src/components/Deposit3.vue
function Deposit3_injectStyle (ssrContext) {
  __webpack_require__("3jBm")
}
var Deposit3_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit3___vue_template_functional__ = false
/* styles */
var Deposit3___vue_styles__ = Deposit3_injectStyle
/* scopeId */
var Deposit3___vue_scopeId__ = "data-v-22575594"
/* moduleIdentifier (server only) */
var Deposit3___vue_module_identifier__ = null
var Deposit3_Component = Deposit3_normalizeComponent(
  components_Deposit3,
  selectortype_template_index_0_src_components_Deposit3,
  Deposit3___vue_template_functional__,
  Deposit3___vue_styles__,
  Deposit3___vue_scopeId__,
  Deposit3___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit3 = (Deposit3_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Alipay.vue
















/* harmony default export */ var Alipay = ({
  data: function data() {
    return {
      contents: [{
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/1.png',
        'subtitle': '请截图或点击保存二维码'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/2.png',
        'subtitle': '使用本机或其他手机<br />扫描二维码支付提示金额'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/3.png',
        'subtitle': '请务必在规定时间内完成支付'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/4.png',
        'subtitle': '<span style="color: #E02020">*切勿转账给在线客服<br />*如转账中遇到风险提示，请参照以下措施</span><br />一、请点击关闭或取消继续付款<br />二、重新发起充值订单<br />三、更换付款账号进行付款'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/5.png',
        'subtitle': '切勿重复扫码支付，以免造成资金损失'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/6.png',
        'subtitle': '如充值不到账，<br />请点击“我”中的“积分”进入收银台<br />再点击“在线客服”'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/7.png',
        'subtitle': '请提供游戏ID及充值截图给客服查询'
      }],
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Alipay.vue
















/* harmony default export */ var components_Alipay = ({
  data: function data() {
    return {
      contents: [{
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/1.png',
        'subtitle': '请截图或点击保存二维码'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/2.png',
        'subtitle': '使用本机或其他手机<br />扫描二维码支付提示金额'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/3.png',
        'subtitle': '请务必在规定时间内完成支付'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/4.png',
        'subtitle': '<span style="color: #E02020">*切勿转账给在线客服<br />*如转账中遇到风险提示，请参照以下措施</span><br />一、请点击关闭或取消继续付款<br />二、重新发起充值订单<br />三、更换付款账号进行付款'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/5.png',
        'subtitle': '切勿重复扫码支付，以免造成资金损失'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/6.png',
        'subtitle': '如充值不到账，<br />请点击“我”中的“积分”进入收银台<br />再点击“在线客服”'
      }, {
        'title': '支付宝',
        'img': '../../static/images/guide/alipay/7.png',
        'subtitle': '请提供游戏ID及充值截图给客服查询'
      }],
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d922a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alipay.vue
var Alipay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-alipay",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"支付宝充值教程","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('swiper',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"show-desc-mask":false,"show-dots":false,"auto":_vm.play,"aspect-ratio":950/500}},_vm._l((_vm.contents),function(item,index){return _c('swiper-item',{key:index,staticStyle:{"text-align":"center"}},[_c('h1',{staticStyle:{"font-size":"14px","font-weight":"normal","color":"#999","margin":"15px 0 0 0"}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block"},attrs:{"src":item.img,"width":"65%"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(index+1)+"/"+_vm._s(_vm.contents.length))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"10px 0 0 0","font-size":"14px"},domProps:{"innerHTML":_vm._s(item.subtitle)}})])}),1)],1)],2)],1)}
var Alipay_staticRenderFns = []
var Alipay_esExports = { render: Alipay_render, staticRenderFns: Alipay_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Alipay = (Alipay_esExports);
// CONCATENATED MODULE: ./src/components/Alipay.vue
function Alipay_injectStyle (ssrContext) {
  __webpack_require__("+ife")
}
var Alipay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Alipay___vue_template_functional__ = false
/* styles */
var Alipay___vue_styles__ = Alipay_injectStyle
/* scopeId */
var Alipay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Alipay___vue_module_identifier__ = null
var Alipay_Component = Alipay_normalizeComponent(
  components_Alipay,
  selectortype_template_index_0_src_components_Alipay,
  Alipay___vue_template_functional__,
  Alipay___vue_styles__,
  Alipay___vue_scopeId__,
  Alipay___vue_module_identifier__
)

/* harmony default export */ var src_components_Alipay = (Alipay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Bankcard.vue
















/* harmony default export */ var Bankcard = ({
  data: function data() {
    return {
      contents: [{
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/1.png',
        'subtitle': '请按照提示操作进行转账充值'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/2.png',
        'subtitle': '请按照提示金额转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/3.png',
        'subtitle': '请在规定时间内完成转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/4.png',
        'subtitle': '请正确填写收款信息，切勿重复转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/5.png',
        'subtitle': '<span style="color: #E02020">*切勿转账给在线客服<br />*如转账中遇到风险提示，请参照以下措施</span><br />一、请点击关闭或取消继续付款<br />二、重新发起充值订单<br />三、更换付款账号进行付款'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/6.png',
        'subtitle': '如充值不到账，<br />请点击“我”中的“积分”进入收银台<br />再点击“在线客服”'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/7.png',
        'subtitle': '请提供游戏ID及充值截图给客服查询'
      }],
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Bankcard.vue
















/* harmony default export */ var components_Bankcard = ({
  data: function data() {
    return {
      contents: [{
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/1.png',
        'subtitle': '请按照提示操作进行转账充值'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/2.png',
        'subtitle': '请按照提示金额转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/3.png',
        'subtitle': '请在规定时间内完成转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/4.png',
        'subtitle': '请正确填写收款信息，切勿重复转账'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/5.png',
        'subtitle': '<span style="color: #E02020">*切勿转账给在线客服<br />*如转账中遇到风险提示，请参照以下措施</span><br />一、请点击关闭或取消继续付款<br />二、重新发起充值订单<br />三、更换付款账号进行付款'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/6.png',
        'subtitle': '如充值不到账，<br />请点击“我”中的“积分”进入收银台<br />再点击“在线客服”'
      }, {
        'title': '银行卡',
        'img': '../../static/images/guide/bankcard/7.png',
        'subtitle': '请提供游戏ID及充值截图给客服查询'
      }],
      play: false,
      loaded: false
    };
  },

  components: {
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Loading: vux_src_components_loading,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    cookie: cookie["a" /* default */]
  },
  mounted: function mounted() {
    this.loaded = true;
    this.play = true;
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266ab564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bankcard.vue
var Bankcard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-bankcard",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"银行卡充值教程","left-options":{backText: ''}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('swiper',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"show-desc-mask":false,"show-dots":false,"auto":"","aspect-ratio":950/500}},_vm._l((_vm.contents),function(item,index){return _c('swiper-item',{key:index,staticStyle:{"text-align":"center"}},[_c('h1',{staticStyle:{"font-size":"14px","font-weight":"normal","color":"#999","margin":"15px 0 0 0"}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('img',{staticStyle:{"display":"inline-block"},attrs:{"src":item.img,"width":"65%"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(index+1)+"/"+_vm._s(_vm.contents.length))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"10px 0 0 0","font-size":"14px"},domProps:{"innerHTML":_vm._s(item.subtitle)}})])}),1)],1)],2)],1)}
var Bankcard_staticRenderFns = []
var Bankcard_esExports = { render: Bankcard_render, staticRenderFns: Bankcard_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Bankcard = (Bankcard_esExports);
// CONCATENATED MODULE: ./src/components/Bankcard.vue
function Bankcard_injectStyle (ssrContext) {
  __webpack_require__("izpx")
}
var Bankcard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Bankcard___vue_template_functional__ = false
/* styles */
var Bankcard___vue_styles__ = Bankcard_injectStyle
/* scopeId */
var Bankcard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Bankcard___vue_module_identifier__ = null
var Bankcard_Component = Bankcard_normalizeComponent(
  components_Bankcard,
  selectortype_template_index_0_src_components_Bankcard,
  Bankcard___vue_template_functional__,
  Bankcard___vue_styles__,
  Bankcard___vue_scopeId__,
  Bankcard___vue_module_identifier__
)

/* harmony default export */ var src_components_Bankcard = (Bankcard_Component.exports);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/QRCode.js
var QRCode = __webpack_require__("0k+n");
var QRCode_default = /*#__PURE__*/__webpack_require__.n(QRCode);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/ErrorCorrectLevel.js
var ErrorCorrectLevel = __webpack_require__("LpmL");
var ErrorCorrectLevel_default = /*#__PURE__*/__webpack_require__.n(ErrorCorrectLevel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(qrcode_utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / qrcode_getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function qrcode_getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function qrcode_utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0c502d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/qrcode/index.vue
var qrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'canvas'),expression:"type === 'canvas'"}],ref:"canvas",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"height":_vm.size,"width":_vm.size}}),_vm._v(" "),(_vm.type === 'img')?_c('img',{style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"src":_vm.imgData}}):_vm._e()])}
var qrcode_staticRenderFns = []
var qrcode_esExports = { render: qrcode_render, staticRenderFns: qrcode_staticRenderFns }
/* harmony default export */ var vux_src_components_qrcode = (qrcode_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/qrcode/index.vue
var qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrcode___vue_template_functional__ = false
/* styles */
var qrcode___vue_styles__ = null
/* scopeId */
var qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var qrcode___vue_module_identifier__ = null
var qrcode_Component = qrcode_normalizeComponent(
  src_components_qrcode,
  vux_src_components_qrcode,
  qrcode___vue_template_functional__,
  qrcode___vue_styles__,
  qrcode___vue_scopeId__,
  qrcode___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_qrcode = (qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a8526d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("KKZb")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["a" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f818f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon,"alt":""}})]})],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("C+Ij")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c88812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group-title/index.vue
var group_title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells__title"},[_vm._t("default")],2)}
var group_title_staticRenderFns = []
var group_title_esExports = { render: group_title_render, staticRenderFns: group_title_staticRenderFns }
/* harmony default export */ var src_components_group_title = (group_title_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group-title/index.vue
function group_title_injectStyle (ssrContext) {
  __webpack_require__("hwJY")
}
var group_title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group_title___vue_template_functional__ = false
/* styles */
var group_title___vue_styles__ = group_title_injectStyle
/* scopeId */
var group_title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_title___vue_module_identifier__ = null
var group_title_Component = group_title_normalizeComponent(
  components_group_title,
  src_components_group_title,
  group_title___vue_template_functional__,
  group_title___vue_styles__,
  group_title___vue_scopeId__,
  group_title___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group_title = (group_title_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263730af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("LWON")
}
var divider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = (divider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Qrcode.vue
















/* harmony default export */ var Qrcode = ({
  data: function data() {
    return {
      amount: 0,
      address: '',
      scripts: '00000000',
      totalTime: 90,
      content: '90',
      languages: [{
        key: 'cn',
        value: 'zh_CN'
      }, {
        key: 'tw',
        value: 'zh_TW'
      }, {
        key: 'en',
        value: 'EN'
      }, {
        key: 'vn',
        value: 'VN'
      }],
      selectoption: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.qrcode = this.$router.currentRoute.query.qrcode;
    this.$models.Deposit.qrcode({ order_no: this.qrcode }).then(function (response) {
      if (response.data.success) {
        response = response.data.data;
        _this.address = response.address;
        _this.scripts = response.scripts;
        _this.amount = response.symbol + ' ' + response.amount;
      } else {
        _this.$router.replace({
          path: '/error',
          query: {
            title: '' + _this.$t('channelUnavailable'),
            description1: '' + response.data.message
          }
        });
      }
    });
    this.setLocale();
    this.countDown();
  },

  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    XButton: vux_src_components_x_button,
    ViewBox: vux_src_components_view_box,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Divider: vux_src_components_divider,
    XInput: vux_src_components_x_input,
    Popup: node_modules_vux_src_components_popup,
    PopupRadio: vux_src_components_popup_radio
  },
  methods: {
    countDown: function countDown() {
      var _this2 = this;

      var clock = window.setInterval(function () {
        _this2.totalTime--;
        _this2.content = _this2.totalTime;
        if (_this2.totalTime < 1) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
        }
      }, 1000);
    },
    copy: function copy() {
      navigator.clipboard.writeText(this.qrcode || '');
    },
    setLocale: function setLocale() {
      var _this3 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this3.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this3.$i18n.locale = lang;
        }

        _this3.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;

      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languages = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Qrcode.vue
















/* harmony default export */ var components_Qrcode = ({
  data: function data() {
    return {
      amount: 0,
      address: '',
      scripts: '00000000',
      totalTime: 90,
      content: '90',
      languages: [{
        key: 'cn',
        value: 'zh_CN'
      }, {
        key: 'tw',
        value: 'zh_TW'
      }, {
        key: 'en',
        value: 'EN'
      }, {
        key: 'vn',
        value: 'VN'
      }],
      selectoption: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.qrcode = this.$router.currentRoute.query.qrcode;
    this.$models.Deposit.qrcode({ order_no: this.qrcode }).then(function (response) {
      if (response.data.success) {
        response = response.data.data;
        _this.address = response.address;
        _this.scripts = response.scripts;
        _this.amount = response.symbol + ' ' + response.amount;
      } else {
        _this.$router.replace({
          path: '/error',
          query: {
            title: '' + _this.$t('channelUnavailable'),
            description1: '' + response.data.message
          }
        });
      }
    });
    this.setLocale();
    this.countDown();
  },

  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    XButton: vux_src_components_x_button,
    ViewBox: vux_src_components_view_box,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Divider: vux_src_components_divider,
    XInput: vux_src_components_x_input,
    Popup: node_modules_vux_src_components_popup,
    PopupRadio: vux_src_components_popup_radio
  },
  methods: {
    countDown: function countDown() {
      var _this2 = this;

      var clock = window.setInterval(function () {
        _this2.totalTime--;
        _this2.content = _this2.totalTime;
        if (_this2.totalTime < 1) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
        }
      }, 1000);
    },
    copy: function copy() {
      navigator.clipboard.writeText(this.qrcode || '');
    },
    setLocale: function setLocale() {
      var _this3 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this3.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this3.$i18n.locale = lang;
        }

        _this3.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;

      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languages = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a68552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Qrcode.vue
var Qrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-qrcode",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"chooselang"},[_c('img',{attrs:{"src":__webpack_require__("q29H"),"alt":"language"}}),_vm._v(" "),_c('div',{staticClass:"langcon"},[_c('popup-radio',{attrs:{"title":"","options":_vm.languages},on:{"on-hide":_vm.switchLang},model:{value:(_vm.selectoption),callback:function ($$v) {_vm.selectoption=$$v},expression:"selectoption"}},[_c('p',{staticClass:"popupheadercon",attrs:{"slot":"popup-header"},slot:"popup-header"},[_vm._v(_vm._s(_vm.$t('chooseLanguage')))])])],1)]),_vm._v(" "),_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":_vm.$t('qrcode'),"left-options":{ showBack: false, backText: '' }},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('div',{staticStyle:{"margin-top":"50px"}},[_c('qrcode',{staticClass:"qrcode",attrs:{"size":200,"value":_vm.address,"type":"img"}}),_vm._v(" "),_c('div',{staticStyle:{"padding":"40px 30px"}},[_c('group-title',[_vm._v(_vm._s(_vm.$t('orderInfo')))]),_vm._v(" "),_c('grid',{staticClass:"grid-center"},[_c('grid-item',[_vm._v(_vm._s(_vm.$t('payAmount')))]),_vm._v(" "),_c('grid-item',{staticStyle:{"color":"red"}},[_vm._v("\n              "+_vm._s(_vm.amount)+"\n            ")])],1),_vm._v(" "),_c('group-title',[_vm._v(_vm._s(_vm.$t('address')))]),_vm._v(" "),_c('grid',[_c('grid-item',{on:{"on-item-click":function($event){return _vm.copy()}}},[_c('span',{staticClass:"grid-center"},[_vm._v("\n                "+_vm._s(_vm.address)+"\n                "),_c('x-button',{attrs:{"mini":"","gradients":['#1D62F0', '#19D5FD']}},[_vm._v(_vm._s(_vm.$t('copy')))])],1)])],1),_vm._v(" "),_c('divider'),_vm._v(" "),_c('group-title',[_vm._v(_vm._s(_vm.$t('scripts')))]),_vm._v(" "),_c('grid',[_c('grid-item',[_c('span',{staticClass:"grid-center"},[_c('x-button',{attrs:{"gradients":['#FF5E3A', '#FF9500']}},[_vm._v(_vm._s(_vm.scripts))])],1)])],1),_vm._v(" "),_c('divider',[_vm._v(_vm._s(_vm.$t('tips')))]),_vm._v(" "),_c('p',[_vm._v("1、"+_vm._s(_vm.$t('scanQrcode')))]),_vm._v(" "),_c('p',[_vm._v("2、"+_vm._s(_vm.$t('screenshotAndScript')))])],1)],1)])],2)],1)}
var Qrcode_staticRenderFns = []
var Qrcode_esExports = { render: Qrcode_render, staticRenderFns: Qrcode_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Qrcode = (Qrcode_esExports);
// CONCATENATED MODULE: ./src/components/Qrcode.vue
function Qrcode_injectStyle (ssrContext) {
  __webpack_require__("Mk4V")
}
var Qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Qrcode___vue_template_functional__ = false
/* styles */
var Qrcode___vue_styles__ = Qrcode_injectStyle
/* scopeId */
var Qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Qrcode___vue_module_identifier__ = null
var Qrcode_Component = Qrcode_normalizeComponent(
  components_Qrcode,
  selectortype_template_index_0_src_components_Qrcode,
  Qrcode___vue_template_functional__,
  Qrcode___vue_styles__,
  Qrcode___vue_scopeId__,
  Qrcode___vue_module_identifier__
)

/* harmony default export */ var src_components_Qrcode = (Qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["a" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["a" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb41afc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/msg/index.vue
var msg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg"},[_c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"weui-icon_msg",class:("weui-icon-" + (_vm.icon || 'success'))})]),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('h2',{staticClass:"weui-msg__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-msg__desc"},[_vm._t("description")],2),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"weui-msg__desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-msg__opr-area"},[_c('p',{staticClass:"weui-btn-area"},[_vm._t("buttons",function(){return _vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"weui-btn",class:("weui-btn_" + (button.type)),attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onClick(button.onClick, button.link)}}},[_vm._v(_vm._s(button.text))])})})],2)])])}
var msg_staticRenderFns = []
var msg_esExports = { render: msg_render, staticRenderFns: msg_staticRenderFns }
/* harmony default export */ var src_components_msg = (msg_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/msg/index.vue
function msg_injectStyle (ssrContext) {
  __webpack_require__("XHW0")
}
var msg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var msg___vue_template_functional__ = false
/* styles */
var msg___vue_styles__ = msg_injectStyle
/* scopeId */
var msg___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var msg___vue_module_identifier__ = null
var msg_Component = msg_normalizeComponent(
  components_msg,
  src_components_msg,
  msg___vue_template_functional__,
  msg___vue_styles__,
  msg___vue_scopeId__,
  msg___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_msg = (msg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Finished.vue





/* harmony default export */ var Finished = ({
  components: {
    Msg: vux_src_components_msg
  },
  mounted: function mounted() {
    this.setLocale();
  },

  methods: {
    setLocale: function setLocale() {
      var _this = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this.$i18n.locale = lang;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Finished.vue





/* harmony default export */ var components_Finished = ({
  components: {
    Msg: vux_src_components_msg
  },
  mounted: function mounted() {
    this.setLocale();
  },

  methods: {
    setLocale: function setLocale() {
      var _this = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this.$i18n.locale = lang;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f962b5ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finished.vue
var Finished_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished",staticStyle:{"height":"100%"}},[_c('msg',{attrs:{"title":_vm.$t('paid'),"icon":"success"}})],1)}
var Finished_staticRenderFns = []
var Finished_esExports = { render: Finished_render, staticRenderFns: Finished_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Finished = (Finished_esExports);
// CONCATENATED MODULE: ./src/components/Finished.vue
var Finished_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Finished___vue_template_functional__ = false
/* styles */
var Finished___vue_styles__ = null
/* scopeId */
var Finished___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Finished___vue_module_identifier__ = null
var Finished_Component = Finished_normalizeComponent(
  components_Finished,
  selectortype_template_index_0_src_components_Finished,
  Finished___vue_template_functional__,
  Finished___vue_styles__,
  Finished___vue_scopeId__,
  Finished___vue_module_identifier__
)

/* harmony default export */ var src_components_Finished = (Finished_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Error.vue



/* harmony default export */ var Error = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      title: '未知错误',
      description1: '',
      description2: '',
      description3: '',
      description4: '',
      description5: ''
    };
  },
  mounted: function mounted() {
    if (typeof this.$route.query.title === 'string') {
      this.title = this.$route.query.title;
    }
    if (typeof this.$route.query.description1 === 'string') {
      this.description1 = this.$route.query.description1;
    }
    if (typeof this.$route.query.description2 === 'string') {
      this.description2 = this.$route.query.description2;
    }
    if (typeof this.$route.query.description3 === 'string') {
      this.description3 = this.$route.query.description3;
    }
    if (typeof this.$route.query.description4 === 'string') {
      this.description4 = this.$route.query.description4;
    }
    if (typeof this.$route.query.description5 === 'string') {
      this.description5 = this.$route.query.description5;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Error.vue



/* harmony default export */ var components_Error = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      title: '未知错误',
      description1: '',
      description2: '',
      description3: '',
      description4: '',
      description5: ''
    };
  },
  mounted: function mounted() {
    if (typeof this.$route.query.title === 'string') {
      this.title = this.$route.query.title;
    }
    if (typeof this.$route.query.description1 === 'string') {
      this.description1 = this.$route.query.description1;
    }
    if (typeof this.$route.query.description2 === 'string') {
      this.description2 = this.$route.query.description2;
    }
    if (typeof this.$route.query.description3 === 'string') {
      this.description3 = this.$route.query.description3;
    }
    if (typeof this.$route.query.description4 === 'string') {
      this.description4 = this.$route.query.description4;
    }
    if (typeof this.$route.query.description5 === 'string') {
      this.description5 = this.$route.query.description5;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c233094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
var Error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished",staticStyle:{"height":"100%"}},[_c('msg',{attrs:{"title":_vm.title,"icon":"warn"}},[_c('p',{attrs:{"slot":"description"},slot:"description"},[_c('span',[_vm._v(_vm._s(_vm.description1))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description2))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description3))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description4))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description5))]),_c('br')])])],1)}
var Error_staticRenderFns = []
var Error_esExports = { render: Error_render, staticRenderFns: Error_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Error = (Error_esExports);
// CONCATENATED MODULE: ./src/components/Error.vue
var Error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Error___vue_template_functional__ = false
/* styles */
var Error___vue_styles__ = null
/* scopeId */
var Error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Error___vue_module_identifier__ = null
var Error_Component = Error_normalizeComponent(
  components_Error,
  selectortype_template_index_0_src_components_Error,
  Error___vue_template_functional__,
  Error___vue_styles__,
  Error___vue_scopeId__,
  Error___vue_module_identifier__
)

/* harmony default export */ var src_components_Error = (Error_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97cc156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
var cell_form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-cell-form-preview",class:{'vux-cell-no-border-intent': !_vm.borderIntent}},[_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(item.value)}})])}),0)])}
var cell_form_preview_staticRenderFns = []
var cell_form_preview_esExports = { render: cell_form_preview_render, staticRenderFns: cell_form_preview_staticRenderFns }
/* harmony default export */ var src_components_cell_form_preview = (cell_form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-form-preview/index.vue
function cell_form_preview_injectStyle (ssrContext) {
  __webpack_require__("CRVH")
}
var cell_form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_form_preview___vue_template_functional__ = false
/* styles */
var cell_form_preview___vue_styles__ = cell_form_preview_injectStyle
/* scopeId */
var cell_form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_form_preview___vue_module_identifier__ = null
var cell_form_preview_Component = cell_form_preview_normalizeComponent(
  components_cell_form_preview,
  src_components_cell_form_preview,
  cell_form_preview___vue_template_functional__,
  cell_form_preview___vue_styles__,
  cell_form_preview___vue_scopeId__,
  cell_form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_form_preview = (cell_form_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/C2C.vue









/* harmony default export */ var C2C = ({
  data: function data() {
    return {
      amount: 0,
      list: [{ label: '交易号', value: 'TX-1234566777777' }, { label: '卡号', value: '1234566777777' }, { label: '收款人', value: '陈一二' }],
      file: null,
      preview: null,
      defaultPreview: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var transId = this.$router.currentRoute.query.transId;

    this.$models.Deposit.c2c({
      trans_id: transId
    }).then(function (response) {
      var _response$data = response.data,
          success = _response$data.success,
          data = _response$data.data;

      if (success) {
        _this.amount = data.amount;
        _this.list = [{ label: '交易号', value: transId || 'undefined' }, { label: '卡号', value: data.card_number }, { label: '收款人', value: data.owner }];
        _this.deadline = data.trans_expire_datetime;
      } else {}
    });
  },

  components: {
    CellFormPreview: vux_src_components_cell_form_preview,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    ViewBox: vux_src_components_view_box,
    Cell: vux_src_components_cell,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button
  },
  methods: {
    previewImage: function previewImage() {
      if (this.preview !== null) {
        this.defaultPreview = 1;
        return this.preview;
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      var file = document.querySelector('input[type=file]').files[0];
      if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
        var reader = new FileReader();
        var rawImg = void 0;
        reader.onloadend = function () {
          rawImg = reader.result;
          if (rawImg) {
            _this2.$emit('load', rawImg);
            _this2.preview = rawImg;
          }
        };
        reader.readAsDataURL(file);
        console.log(file);
      } else {
        this.defaultPreview = 0;
        this.preview = '';
        return this.preview;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/C2C.vue









/* harmony default export */ var components_C2C = ({
  data: function data() {
    return {
      amount: 0,
      list: [{ label: '交易号', value: 'TX-1234566777777' }, { label: '卡号', value: '1234566777777' }, { label: '收款人', value: '陈一二' }],
      file: null,
      preview: null,
      defaultPreview: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var transId = this.$router.currentRoute.query.transId;

    this.$models.Deposit.c2c({
      trans_id: transId
    }).then(function (response) {
      var _response$data = response.data,
          success = _response$data.success,
          data = _response$data.data;

      if (success) {
        _this.amount = data.amount;
        _this.list = [{ label: '交易号', value: transId || 'undefined' }, { label: '卡号', value: data.card_number }, { label: '收款人', value: data.owner }];
        _this.deadline = data.trans_expire_datetime;
      } else {}
    });
  },

  components: {
    CellFormPreview: vux_src_components_cell_form_preview,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    ViewBox: vux_src_components_view_box,
    Cell: vux_src_components_cell,
    Group: vux_src_components_group,
    XButton: vux_src_components_x_button
  },
  methods: {
    previewImage: function previewImage() {
      if (this.preview !== null) {
        this.defaultPreview = 1;
        return this.preview;
      }
    },
    uploadImage: function uploadImage() {
      var _this2 = this;

      var file = document.querySelector('input[type=file]').files[0];
      if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
        var reader = new FileReader();
        var rawImg = void 0;
        reader.onloadend = function () {
          rawImg = reader.result;
          if (rawImg) {
            _this2.$emit('load', rawImg);
            _this2.preview = rawImg;
          }
        };
        reader.readAsDataURL(file);
        console.log(file);
      } else {
        this.defaultPreview = 0;
        this.preview = '';
        return this.preview;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef280d56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/C2C.vue
var C2C_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-qrcode",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值","left-options":{showBack: false, preventGoBack: true}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('div',[_c('group',[_c('cell',{attrs:{"title":"金额","value":_vm.amount}}),_vm._v(" "),_c('cell-form-preview',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('cell',{attrs:{"title":"上传付款图片"}},[_c('input',{attrs:{"type":"file","name":"imagefile","id":"imgfile","accept":"image/x-png,image/jpeg"},on:{"change":function($event){return _vm.uploadImage()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.defaultPreview),expression:"defaultPreview"}],staticClass:"previewimg"},[_c('div',[_vm._v("预览图像")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.previewImage()}})])],1),_vm._v(" "),_c('x-button',{staticClass:"submit-c2cbtn",attrs:{"type":"primary"}},[_vm._v("立即支付")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"40px 30px"}},[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n              1、请于 "+_vm._s(_vm.deadline)+" 时间付款完毕，超时打款，造成损失。需由玩家自行承担"),_c('br')])])],1)])],2)],1)}
var C2C_staticRenderFns = []
var C2C_esExports = { render: C2C_render, staticRenderFns: C2C_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_C2C = (C2C_esExports);
// CONCATENATED MODULE: ./src/components/C2C.vue
function C2C_injectStyle (ssrContext) {
  __webpack_require__("3lpv")
  __webpack_require__("lQZp")
}
var C2C_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var C2C___vue_template_functional__ = false
/* styles */
var C2C___vue_styles__ = C2C_injectStyle
/* scopeId */
var C2C___vue_scopeId__ = "data-v-ef280d56"
/* moduleIdentifier (server only) */
var C2C___vue_module_identifier__ = null
var C2C_Component = C2C_normalizeComponent(
  components_C2C,
  selectortype_template_index_0_src_components_C2C,
  C2C___vue_template_functional__,
  C2C___vue_styles__,
  C2C___vue_scopeId__,
  C2C___vue_module_identifier__
)

/* harmony default export */ var src_components_C2C = (C2C_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var memoryStore = {};

var storage = {
  getItem: function getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return memoryStore[key] !== undefined ? memoryStore[key] : null;
    }
  },
  setItem: function setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      memoryStore[key] = String(value);
    }
  }
};

/* harmony default export */ var Loading = ({
  name: 'Loading',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var circumference = 2 * Math.PI * 44;
    return {
      currentTheme: 0,
      totalTime: 0,
      maxTime: 0,
      circumference: circumference,
      clock: null
    };
  },

  computed: {
    dashOffset: function dashOffset() {
      return this.maxTime === 0 ? 0 : this.circumference * (1 - this.totalTime / this.maxTime);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var theme = storage.getItem('theme');
    this.currentTheme = theme === null ? 1 : Number(theme);

    var orderNo = this.$router.currentRoute.query.order_no;
    var maxTtlKey = 'max_ttl_' + orderNo;
    this.$models.Deposit.resource({ order_no: orderNo }).then(function (response) {
      var diff = response.data.data && response.data.data.ttl;
      var stored = storage.getItem(maxTtlKey);
      if (stored) {
        _this.maxTime = Number(stored);
      } else {
        _this.maxTime = diff;
        storage.setItem(maxTtlKey, diff);
      }
      _this.totalTime = diff;
      _this.startCountDown();
    }).catch(function () {
      _this.$router.replace({
        path: '/error',
        query: {
          title: '' + _this.$t('channelUnavailable'),
          description1: '' + _this.$t('recreateOrder')
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clock) {
      window.clearInterval(this.clock);
    }
  },

  methods: {
    startCountDown: function startCountDown() {
      var _this2 = this;

      this.clock = window.setInterval(function () {
        _this2.totalTime--;
        if (_this2.totalTime < 1) {
          window.clearInterval(_this2.clock);
          _this2.$router.replace({
            path: '/error',
            query: {
              title: '' + _this2.$t('channelUnavailable'),
              description1: '' + _this2.$t('recreateOrder')
            }
          });
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Loading_memoryStore = {};

var Loading_storage = {
  getItem: function getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return Loading_memoryStore[key] !== undefined ? Loading_memoryStore[key] : null;
    }
  },
  setItem: function setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      Loading_memoryStore[key] = String(value);
    }
  }
};

/* harmony default export */ var components_Loading = ({
  name: 'Loading',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var circumference = 2 * Math.PI * 44;
    return {
      currentTheme: 0,
      totalTime: 0,
      maxTime: 0,
      circumference: circumference,
      clock: null
    };
  },

  computed: {
    dashOffset: function dashOffset() {
      return this.maxTime === 0 ? 0 : this.circumference * (1 - this.totalTime / this.maxTime);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var theme = Loading_storage.getItem('theme');
    this.currentTheme = theme === null ? 1 : Number(theme);

    var orderNo = this.$router.currentRoute.query.order_no;
    var maxTtlKey = 'max_ttl_' + orderNo;
    this.$models.Deposit.resource({ order_no: orderNo }).then(function (response) {
      var diff = response.data.data && response.data.data.ttl;
      var stored = Loading_storage.getItem(maxTtlKey);
      if (stored) {
        _this.maxTime = Number(stored);
      } else {
        _this.maxTime = diff;
        Loading_storage.setItem(maxTtlKey, diff);
      }
      _this.totalTime = diff;
      _this.startCountDown();
    }).catch(function () {
      _this.$router.replace({
        path: '/error',
        query: {
          title: '' + _this.$t('channelUnavailable'),
          description1: '' + _this.$t('recreateOrder')
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clock) {
      window.clearInterval(this.clock);
    }
  },

  methods: {
    startCountDown: function startCountDown() {
      var _this2 = this;

      this.clock = window.setInterval(function () {
        _this2.totalTime--;
        if (_this2.totalTime < 1) {
          window.clearInterval(_this2.clock);
          _this2.$router.replace({
            path: '/error',
            query: {
              title: '' + _this2.$t('channelUnavailable'),
              description1: '' + _this2.$t('recreateOrder')
            }
          });
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a1b28e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
var Loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page",class:_vm.currentTheme === 1 ? 'dark' : 'light',staticStyle:{"height":"100%"}},[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"countdown-ring"},[_c('svg',{staticClass:"ring-svg",attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{staticClass:"ring-track",attrs:{"cx":"50","cy":"50","r":"44"}}),_vm._v(" "),_c('circle',{staticClass:"ring-progress",attrs:{"cx":"50","cy":"50","r":"44","stroke-dasharray":_vm.circumference,"stroke-dashoffset":_vm.dashOffset}})]),_vm._v(" "),_c('div',{staticClass:"countdown-number"},[_vm._v(_vm._s(_vm.totalTime))])]),_vm._v(" "),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.message || _vm.$t('loading')))])])])}
var Loading_staticRenderFns = []
var Loading_esExports = { render: Loading_render, staticRenderFns: Loading_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Loading = (Loading_esExports);
// CONCATENATED MODULE: ./src/components/Loading.vue
function Loading_injectStyle (ssrContext) {
  __webpack_require__("LbSN")
}
var Loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loading___vue_template_functional__ = false
/* styles */
var Loading___vue_styles__ = Loading_injectStyle
/* scopeId */
var Loading___vue_scopeId__ = "data-v-9a1b28e6"
/* moduleIdentifier (server only) */
var Loading___vue_module_identifier__ = null
var Loading_Component = Loading_normalizeComponent(
  components_Loading,
  selectortype_template_index_0_src_components_Loading,
  Loading___vue_template_functional__,
  Loading___vue_styles__,
  Loading___vue_scopeId__,
  Loading___vue_module_identifier__
)

/* harmony default export */ var src_components_Loading = (Loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Order.vue







/* harmony default export */ var Order = ({
  data: function data() {
    return {
      order_no: '',
      amount: '0.00',
      symbol: '¥',
      account: '',
      surname: '',
      name: '',
      payment_flow: '',
      totalTime: 0,
      clockHandle: null,
      languages: [{ key: 'cn', value: 'zh_CN' }, { key: 'tw', value: 'zh_TW' }, { key: 'en', value: 'EN' }, { key: 'vn', value: 'VN' }],
      selectoption: '',
      proofFile: null,
      previewUrl: '',
      uploading: false
    };
  },

  computed: {
    countdownMin: function countdownMin() {
      return String(Math.floor(this.totalTime / 60)).padStart(2, '0');
    },
    countdownSec: function countdownSec() {
      return String(this.totalTime % 60).padStart(2, '0');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.order_no = this.$route.query.order_no;
    this.$models.Deposit.order({ order_no: this.order_no }).then(function (response) {
      if (response.data.success && response.data.data.ttl > 0) {
        var data = response.data.data;
        _this.amount = data.amount;
        _this.symbol = data.symbol || '¥';
        _this.account = data.account || '';
        _this.surname = data.surname || '';
        _this.name = data.name || '';
        _this.payment_flow = '首页-转账-转到支付宝-输入页面上提供的支付宝账户-输入页面上提供的支付宝姓氏首字<br />如系统仅提供数字账号，转账时请勿选择带有邮箱账号之收款户';
        _this.totalTime = data.ttl || 0;
        _this.startCountdown();
      } else {
        _this.$router.replace({
          path: '/error',
          query: {
            title: response.data.message || 'The order is expired',
            description1: ''
          }
        });
      }
    });
    this.setLocale();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clockHandle) {
      window.clearInterval(this.clockHandle);
    }
  },

  components: {
    XHeader: vux_src_components_x_header,
    ViewBox: vux_src_components_view_box,
    PopupRadio: vux_src_components_popup_radio
  },
  methods: {
    startCountdown: function startCountdown() {
      var _this2 = this;

      this.clockHandle = window.setInterval(function () {
        if (_this2.totalTime > 0) {
          _this2.totalTime--;
        } else {
          window.clearInterval(_this2.clockHandle);
        }
      }, 1000);
    },
    copyText: function copyText(text) {
      var _this3 = this;

      navigator.clipboard.writeText(text || '').then(function () {
        _this3.$vux.toast.show({ text: _this3.$t('copied'), type: 'success', time: 1000 });
      });
    },
    setLocale: function setLocale() {
      var _this4 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this4.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this4.$i18n.locale = lang;
        }

        _this4.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languages = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    },
    triggerFilePicker: function triggerFilePicker() {
      if (!this.proofFile) {
        this.$refs.fileInput.click();
      }
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      if (!file) return;
      this.proofFile = file;
      this.previewUrl = URL.createObjectURL(file);

      e.target.value = '';
    },
    submitProof: function submitProof() {
      var _this5 = this;

      if (!this.proofFile || this.uploading) return;
      this.uploading = true;

      var formData = new FormData();
      formData.append('order_no', this.order_no);
      formData.append('image', this.proofFile);

      this.$models.Deposit.uploadProof(formData).then(function (response) {
        if (response.data.success) {
          _this5.$router.replace({ path: '/finished' });
        } else {
          _this5.$vux.toast.show({ text: response.data.message, type: 'warn', time: 2000 });
          _this5.uploading = false;
        }
      }).catch(function () {
        _this5.$vux.toast.show({ text: _this5.$t('uploadFailed'), type: 'warn', time: 2000 });
        _this5.uploading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Order.vue







/* harmony default export */ var components_Order = ({
  data: function data() {
    return {
      order_no: '',
      amount: '0.00',
      symbol: '¥',
      account: '',
      surname: '',
      name: '',
      payment_flow: '',
      totalTime: 0,
      clockHandle: null,
      languages: [{ key: 'cn', value: 'zh_CN' }, { key: 'tw', value: 'zh_TW' }, { key: 'en', value: 'EN' }, { key: 'vn', value: 'VN' }],
      selectoption: '',
      proofFile: null,
      previewUrl: '',
      uploading: false
    };
  },

  computed: {
    countdownMin: function countdownMin() {
      return String(Math.floor(this.totalTime / 60)).padStart(2, '0');
    },
    countdownSec: function countdownSec() {
      return String(this.totalTime % 60).padStart(2, '0');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.order_no = this.$route.query.order_no;
    this.$models.Deposit.order({ order_no: this.order_no }).then(function (response) {
      if (response.data.success && response.data.data.ttl > 0) {
        var data = response.data.data;
        _this.amount = data.amount;
        _this.symbol = data.symbol || '¥';
        _this.account = data.account || '';
        _this.surname = data.surname || '';
        _this.name = data.name || '';
        _this.payment_flow = '首页-转账-转到支付宝-输入页面上提供的支付宝账户-输入页面上提供的支付宝姓氏首字<br />如系统仅提供数字账号，转账时请勿选择带有邮箱账号之收款户';
        _this.totalTime = data.ttl || 0;
        _this.startCountdown();
      } else {
        _this.$router.replace({
          path: '/error',
          query: {
            title: response.data.message || 'The order is expired',
            description1: ''
          }
        });
      }
    });
    this.setLocale();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.clockHandle) {
      window.clearInterval(this.clockHandle);
    }
  },

  components: {
    XHeader: vux_src_components_x_header,
    ViewBox: vux_src_components_view_box,
    PopupRadio: vux_src_components_popup_radio
  },
  methods: {
    startCountdown: function startCountdown() {
      var _this2 = this;

      this.clockHandle = window.setInterval(function () {
        if (_this2.totalTime > 0) {
          _this2.totalTime--;
        } else {
          window.clearInterval(_this2.clockHandle);
        }
      }, 1000);
    },
    copyText: function copyText(text) {
      var _this3 = this;

      navigator.clipboard.writeText(text || '').then(function () {
        _this3.$vux.toast.show({ text: _this3.$t('copied'), type: 'success', time: 1000 });
      });
    },
    setLocale: function setLocale() {
      var _this4 = this;

      this.$models.Deposit.ip().then(function (_ref) {
        var data = _ref.data;

        var lang = LANG[data.data.locale_id];
        _this4.selectoption = lang;

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
          _this4.$i18n.locale = lang;
        }

        _this4.resetLangList();
      });
    },
    switchLang: function switchLang() {
      var lang = this.selectoption;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.resetLangList();
    },
    resetLangList: function resetLangList() {
      this.languages = [{ key: 'cn', value: this.$t('cn') }, { key: 'tw', value: this.$t('tw') }, { key: 'en', value: this.$t('en') }, { key: 'vn', value: this.$t('vn') }];
    },
    triggerFilePicker: function triggerFilePicker() {
      if (!this.proofFile) {
        this.$refs.fileInput.click();
      }
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      if (!file) return;
      this.proofFile = file;
      this.previewUrl = URL.createObjectURL(file);

      e.target.value = '';
    },
    submitProof: function submitProof() {
      var _this5 = this;

      if (!this.proofFile || this.uploading) return;
      this.uploading = true;

      var formData = new FormData();
      formData.append('order_no', this.order_no);
      formData.append('image', this.proofFile);

      this.$models.Deposit.uploadProof(formData).then(function (response) {
        if (response.data.success) {
          _this5.$router.replace({ path: '/finished' });
        } else {
          _this5.$vux.toast.show({ text: response.data.message, type: 'warn', time: 2000 });
          _this5.uploading = false;
        }
      }).catch(function () {
        _this5.$vux.toast.show({ text: _this5.$t('uploadFailed'), type: 'warn', time: 2000 });
        _this5.uploading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a911c240","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
var Order_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-page",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"chooselang"},[_c('img',{attrs:{"src":__webpack_require__("q29H"),"alt":"language"}}),_vm._v(" "),_c('div',{staticClass:"langcon"},[_c('popup-radio',{attrs:{"title":"","options":_vm.languages},on:{"on-hide":_vm.switchLang},model:{value:(_vm.selectoption),callback:function ($$v) {_vm.selectoption=$$v},expression:"selectoption"}},[_c('p',{staticClass:"popupheadercon",attrs:{"slot":"popup-header"},slot:"popup-header"},[_vm._v(_vm._s(_vm.$t('chooseLanguage')))])])],1)]),_vm._v(" "),_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"0"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":_vm.$t('orderDetail'),"left-options":{ showBack: false, backText: '' }},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('div',{staticStyle:{"margin-top":"0px"}},[_c('div',{staticClass:"warning-banner"},[_vm._v("\n          ⚠️ "+_vm._s(_vm.$t('paymentWarning'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"order-card"},[(0)?_c('div',{staticClass:"order-no-row"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('orderNumber'))+"：")]),_vm._v(" "),_c('span',{staticClass:"value order-no-value"},[_vm._v(_vm._s(_vm.order_no))]),_vm._v(" "),_c('button',{staticClass:"copy-btn",on:{"click":function($event){return _vm.copyText(_vm.order_no)}}},[_vm._v(_vm._s(_vm.$t('copy')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-row"},[_c('span',{staticClass:"amount-text"},[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm.amount))]),_vm._v(" "),_c('button',{staticClass:"copy-btn copy-btn-sm",on:{"click":function($event){return _vm.copyText(_vm.amount)}}},[_vm._v(_vm._s(_vm.$t('copy')))])]),_vm._v(" "),_c('div',{staticClass:"divider-line"}),_vm._v(" "),(_vm.account)?_c('div',{staticClass:"info-row"},[_c('span',{staticClass:"info-label"},[_vm._v(_vm._s(_vm.$t('alipayAccount')))]),_vm._v(" "),_c('span',{staticClass:"info-value"},[_vm._v(_vm._s(_vm.account))]),_vm._v(" "),_c('button',{staticClass:"copy-btn",on:{"click":function($event){return _vm.copyText(_vm.account)}}},[_vm._v(_vm._s(_vm.$t('copy')))])]):_vm._e(),_vm._v(" "),(_vm.surname)?_c('div',{staticClass:"info-row"},[_c('span',{staticClass:"info-label"},[_vm._v(_vm._s(_vm.$t('alipaySurname')))]),_vm._v(" "),_c('span',{staticClass:"info-value"},[_vm._v(_vm._s(_vm.surname))]),_vm._v(" "),_c('button',{staticClass:"copy-btn",on:{"click":function($event){return _vm.copyText(_vm.surname)}}},[_vm._v(_vm._s(_vm.$t('copy')))])]):_vm._e(),_vm._v(" "),(_vm.name)?_c('div',{staticClass:"info-row"},[_c('span',{staticClass:"info-label"},[_vm._v(_vm._s(_vm.$t('alipayName')))]),_vm._v(" "),_c('span',{staticClass:"info-value"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('button',{staticClass:"copy-btn",on:{"click":function($event){return _vm.copyText(_vm.name)}}},[_vm._v(_vm._s(_vm.$t('copy')))])]):_vm._e(),_vm._v(" "),(_vm.payment_flow)?_c('div',{staticClass:"divider-line"}):_vm._e(),_vm._v(" "),(_vm.payment_flow)?_c('div',{staticClass:"flow-section"},[_c('div',{staticClass:"flow-title"},[_vm._v(_vm._s(_vm.$t('paymentFlow')))]),_vm._v(" "),_c('div',{staticClass:"flow-content",domProps:{"innerHTML":_vm._s(_vm.payment_flow)}})]):_vm._e(),_vm._v(" "),(_vm.totalTime > 0)?_c('div',{staticClass:"countdown-bar"},[_vm._v("\n            "+_vm._s(_vm.$t('pleasePayWithin'))+"\n            "),_c('span',{staticClass:"countdown-num"},[_vm._v(_vm._s(_vm.countdownMin))]),_vm._v(" "+_vm._s(_vm.$t('minute'))+"\n            "),_c('span',{staticClass:"countdown-num"},[_vm._v(_vm._s(_vm.countdownSec))]),_vm._v(" "+_vm._s(_vm.$t('second'))+"\n            "+_vm._s(_vm.$t('countdownSuffix'))+"\n          ")]):_c('div',{staticClass:"countdown-bar expired"},[_vm._v("\n            "+_vm._s(_vm.$t('orderExpired'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"upload-card"},[_c('div',{staticClass:"upload-title"},[_vm._v(_vm._s(_vm.$t('uploadProof')))]),_vm._v(" "),_c('div',{staticClass:"upload-preview",on:{"click":_vm.triggerFilePicker}},[(_vm.previewUrl)?_c('img',{staticClass:"preview-img",attrs:{"src":_vm.previewUrl}}):_c('div',{staticClass:"upload-placeholder"},[_c('span',{staticClass:"upload-plus"},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"upload-hint"},[_vm._v(_vm._s(_vm.$t('selectImage')))])])]),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/jpeg,image/png,image/gif"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('button',{staticClass:"submit-btn",attrs:{"disabled":!_vm.proofFile || _vm.uploading},on:{"click":_vm.submitProof}},[_vm._v("\n            "+_vm._s(_vm.uploading ? _vm.$t('uploading') : _vm.$t('submitProof'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"footer-reminder"},[_c('span',{staticClass:"heart"},[_vm._v("❤")]),_vm._v(" "+_vm._s(_vm.$t('warmReminder'))+"\n        ")])])])],2)],1)}
var Order_staticRenderFns = []
var Order_esExports = { render: Order_render, staticRenderFns: Order_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Order = (Order_esExports);
// CONCATENATED MODULE: ./src/components/Order.vue
function Order_injectStyle (ssrContext) {
  __webpack_require__("0SdS")
}
var Order_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Order___vue_template_functional__ = false
/* styles */
var Order___vue_styles__ = Order_injectStyle
/* scopeId */
var Order___vue_scopeId__ = "data-v-a911c240"
/* moduleIdentifier (server only) */
var Order___vue_module_identifier__ = null
var Order_Component = Order_normalizeComponent(
  components_Order,
  selectortype_template_index_0_src_components_Order,
  Order___vue_template_functional__,
  Order___vue_styles__,
  Order___vue_scopeId__,
  Order___vue_module_identifier__
)

/* harmony default export */ var src_components_Order = (Order_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/locales/lang/en.js
/* harmony default export */ var en = ({
  payment: 'Counter',
  order: 'Order',
  paymentMethod: 'Payment Method',
  choosePaymentMethod: 'Select Payment Method',
  moreOptions: 'More Methods',
  bank: 'Bank',
  name: 'Name',
  enterCardOwnerName: 'Enter the cardholder name of your payment card',
  phoneNumber: 'Mobile',
  enterYourCardPhoneNumber: 'Enter the mobile phone number corresponding to your payment card',
  lowest: 'Lowest',
  highest: 'Highest',
  rmb: 'CNY',
  point: 'Point',
  enterCustomAmount: 'Enter amount',
  payAmount: 'Payment Amount',
  cardNumber: 'Card Number',
  enterCardNumber: 'Enter payment card number',
  payImmediately: 'Pay',
  have: 'Have',
  personSuccess: 'has successfully recharged',
  channelUnavailable: 'The Channel Unavailable',
  paymentType: 'Payment Types',
  orderUnavailable: 'The order does not exist',
  error: 'Error',
  requestAgain: 'The order already exists, please try again',
  orderNumber: 'Order Number',
  enterCardOwner: 'Enter the name of the payment bank card',
  enterRealName: 'Enter your real name',
  enterPhone: 'Enter your mobile number',
  enterAnInteger: 'Enter an integer',
  paymentSupport: 'Recharge support',
  requestTooFrequently: 'Orders are initiated too frequently',
  needToSlowlyRequest: 'Sorry, because you frequently placed orders but did not submit payment',
  waitFiveMinutes: 'Please rest for five minutes and try again, thank you for your cooperation',
  done: 'Done',
  chooseLanguage: 'Choose Language',
  en: 'English',
  vn: 'Vietnamese',
  cn: 'Simplified Chinese',
  tw: 'Traditional Chinese',
  copy: 'Copy',
  tips: 'Tips',
  scanQrcode: 'Scan the QR code or click to copy the address.',
  screenshotAndScript: 'To find the order number, please provide screenshots and postscript code.',
  orderInfo: 'Order Information',
  address: 'Address',
  scripts: 'Scripts',
  qrcode: 'QR Code',
  ipBlock: 'Your has been blocked, please contact your parent.',
  invalidName: 'No real-name authentication',
  paid: 'Payment successful',
  channelMaintain: 'The channel is under maintenance, please contact customer service',
  id_number: 'ID number',
  phone: 'Phone',
  formatWrong: 'format has wrong',
  mobilePlaceholder: 'fill your mobile number (e.g. 254123456789)',
  loading: 'Processing...',
  recreateOrder: 'The channel is currently unavailable. Please recreate the order',
  orderDetail: 'Order Detail',
  paymentWarning: 'Please make payment according to the information shown below',
  alipayAccount: 'Alipay Account',
  alipaySurname: 'Alipay Surname',
  alipayName: 'Alipay Name',
  alipayRealName: 'Alipay Real Name',
  paymentFlow: 'Payment Steps',
  pleasePayWithin: 'Please complete payment within',
  minute: 'min',
  second: 'sec',
  countdownSuffix: ', payment after deadline will not be credited',
  orderExpired: 'Order has expired',
  warmReminder: 'Reminder',
  copied: 'Copied',
  uploadProof: 'Upload Payment Proof',
  selectImage: 'Tap to select image',
  submitProof: 'Submit Proof',
  uploading: 'Uploading...',
  uploadSuccess: 'Upload successful',
  uploadFailed: 'Upload failed, please try again'
});
// CONCATENATED MODULE: ./src/locales/lang/zh-CN.js
/* harmony default export */ var zh_CN = ({
  payment: '充值',
  order: '订单',
  paymentMethod: '付款方式',
  choosePaymentMethod: '选择付款方式',
  moreOptions: '更多充值方式',
  bank: '银行',
  name: '名字',
  enterCardOwnerName: '输入您付款卡的持卡人姓名',
  phoneNumber: '手机号码',
  enterYourCardPhoneNumber: '输入您付款卡对应的手机号',
  lowest: '最低',
  highest: '最高',
  rmb: '元',
  point: '积分',
  enterCustomAmount: '输入自定义金额',
  payAmount: '付款金额',
  cardNumber: '卡号',
  enterCardNumber: '请输入付款卡卡号',
  payImmediately: '立即支付',
  have: '有',
  personSuccess: '的人成功充值',
  channelUnavailable: '暂无可用通道',
  paymentType: '支付类型',
  orderUnavailable: '订单不存在',
  error: '错误',
  requestAgain: '订单已存在，请重新发起',
  orderNumber: '订单号',
  enterCardOwner: '请输入付款银行卡姓名',
  enterRealName: '请输入您的真实姓名',
  enterPhone: '请输入您的手机号码',
  enterAnInteger: '请输入整数',
  paymentSupport: '充值支持',
  requestTooFrequently: '订单发起过于频繁',
  needToSlowlyRequest: '对不起，因您频繁发起订单但未提交支付',
  waitFiveMinutes: '请您休息五分钟再尝试，谢谢您的配合',
  done: '完成',
  chooseLanguage: '选择语言',
  en: '英文',
  vn: '越南文',
  cn: '简体中文',
  tw: '繁体中文',
  copy: '复制',
  tips: '温馨提示',
  scanQrcode: '扫描二维码或点击复制地址',
  screenshotAndScript: '查找单号请提供截图以及附言码',
  orderInfo: '订单信息',
  address: '地址',
  scripts: '附言',
  qrcode: '二维码',
  ipBlock: '您已被屏蔽，请联系您的商家',
  invalidName: '未实名认证',
  paid: '支付成功',
  channelMaintain: '通道维护中，请联系客服',
  id_number: '身分證号',
  phone: '手机号',
  fixWrong: '请修改错误',
  formatWrong: '格式不正确',
  mobilePlaceholder: '填写您的手机号码 (e.g. 254123456789)',
  loading: '处理中...',
  recreateOrder: '当前通道不可用，请重新创建订单',
  orderDetail: '订单详情',
  paymentWarning: '请务必依照下方显示的收款资讯进行支付',
  alipayAccount: '支付宝帐号',
  alipaySurname: '支付宝姓氏',
  alipayName: '支付宝名称',
  alipayRealName: '支付宝实名',
  paymentFlow: '支付流程',
  pleasePayWithin: '请于',
  minute: '分',
  second: '秒',
  countdownSuffix: '内完成支付，超过时间将无法到账',
  orderExpired: '订单已超时，无法到账',
  warmReminder: '温馨提醒',
  copied: '已复制',
  uploadProof: '上传支付凭证',
  selectImage: '点击选择图片',
  submitProof: '提交凭证',
  uploading: '上传中...',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败，请重试'
});
// CONCATENATED MODULE: ./src/locales/lang/zh-TW.js
/* harmony default export */ var zh_TW = ({
  payment: '充值',
  order: '訂單',
  paymentMethod: '付款方式',
  choosePaymentMethod: '選擇付款方式',
  moreOptions: '更多充值方式',
  bank: '銀行',
  name: '名字',
  enterCardOwnerName: '輸入您付款卡的持卡人姓名',
  phoneNumber: '手機號碼',
  enterYourCardPhoneNumber: '輸入您付款卡對應的手機號',
  lowest: '最低',
  highest: '最高',
  rmb: '元',
  point: '積分',
  enterCustomAmount: '輸入自定義金額',
  payAmount: '付款金額',
  cardNumber: '卡號',
  enterCardNumber: '請輸入付款卡卡號',
  payImmediately: '立即支付',
  have: '有',
  personSuccess: '的人成功充值',
  channelUnavailable: '暫無可用通道',
  paymentType: '支付類型',
  orderUnavailable: '訂單不存在',
  error: '錯誤',
  requestAgain: '訂單已存在，請重新發起',
  orderNumber: '訂單號',
  enterCardOwner: '請輸入付款銀行卡姓名',
  enterRealName: '請輸入您的真實姓名',
  enterPhone: '請輸入您的手機號',
  enterAnInteger: '請輸入整數',
  paymentSupport: '充值支持',
  requestTooFrequently: '訂單發起過於頻繁',
  needToSlowlyRequest: '對不起，因您頻繁發起訂單但未提交支付',
  waitFiveMinutes: '請您休息五分鐘再嘗試，謝謝您的配合',
  done: '完成',
  chooseLanguage: '選擇語言',
  en: '英文',
  vn: '越南文',
  cn: '簡體中文',
  tw: '繁體中文',
  copy: '複製',
  tips: '溫馨提示',
  scanQrcode: '掃描 Qrcode 或點擊複製地址',
  screenshotAndScript: '查找單號請提供截圖以及附言碼',
  orderInfo: '訂單信息',
  address: '地址',
  scripts: '附言',
  qrcode: 'QR Code',
  ipBlock: '您已被封锁，请联系您的上层',
  invalidName: '未實名認證',
  paid: '支付成功',
  channelMaintain: '通道維護中，請聯繫客服',
  id_number: '身分證號',
  phone: '手機號',
  fixWrong: '請修改錯誤',
  formatWrong: '格式不正確',
  mobilePlaceholder: '填寫您的手機號碼 (e.g. 254123456789)',
  loading: '處理中...',
  recreateOrder: '當前通道不可用，請重新創建訂單',
  orderDetail: '訂單詳情',
  paymentWarning: '請務必依照下方顯示的收款資訊進行支付',
  alipayAccount: '支付寶帳號',
  alipaySurname: '支付寶姓氏',
  alipayName: '支付寶名稱',
  alipayRealName: '支付寶實名',
  paymentFlow: '支付流程',
  pleasePayWithin: '請於',
  minute: '分',
  second: '秒',
  countdownSuffix: '內完成支付，超過時間將無法到帳',
  orderExpired: '訂單已超時，無法到帳',
  warmReminder: '溫馨提醒',
  copied: '已複製',
  uploadProof: '上傳支付憑證',
  selectImage: '點擊選擇圖片',
  submitProof: '提交憑證',
  uploading: '上傳中...',
  uploadSuccess: '上傳成功',
  uploadFailed: '上傳失敗，請重試'
});
// CONCATENATED MODULE: ./src/locales/lang/vn.js
/* harmony default export */ var vn = ({
  payment: 'nạp điện',
  order: 'Đơn hàng',
  paymentMethod: 'phương thức thanh toán',
  choosePaymentMethod: 'tùy chọn',
  moreOptions: 'Nhiều phương thức nạp tiền hơn',
  bank: 'ngân hàng',
  name: 'Tên',
  enterCardOwnerName: 'Nhập tên chủ thẻ của thẻ thanh toán của bạn',
  phoneNumber: 'Số điện thoại di động',
  enterYourCardPhoneNumber: 'Nhập số điện thoại di động của thẻ thanh toán của bạn',
  lowest: 'thấp nhất',
  highest: 'Cao nhất',
  rmb: 'Nhân dân tệ',
  point: 'tích phân',
  enterCustomAmount: 'Nhập số tiền tùy chỉnh',
  payAmount: 'Số tiền thanh toán',
  cardNumber: 'số thẻ',
  enterCardNumber: 'Vui lòng nhập số thẻ thanh toán',
  payImmediately: 'thanh toan ngay',
  have: 'có',
  personSuccess: 'người đã nạp tiền thành công',
  channelUnavailable: 'Không có kênh nào',
  paymentType: 'Phương thức thanh toán',
  orderUnavailable: 'đơn đặt hàng không tồn tại',
  error: 'sai lầm',
  requestAgain: 'Đơn hàng đã tồn tại, vui lòng thử lại',
  orderNumber: 'số thứ tự',
  enterCardOwner: 'Vui lòng nhập tên của thẻ ngân hàng thanh toán',
  enterRealName: 'vui lòng nhập tên thật của bạn',
  enterPhone: 'xin vui lòng điền số điện thoại của bạn',
  enterAnInteger: 'Vui lòng nhập một số nguyên',
  paymentSupport: 'Hỗ trợ nạp tiền',
  requestTooFrequently: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
  needToSlowlyRequest: 'Xin lỗi, vì bạn đã thường xuyên đặt hàng nhưng không gửi thanh toán',
  waitFiveMinutes: 'Hãy nghỉ ngơi trong năm phút và thử lại, cảm ơn bạn đã hợp tác',
  done: 'Kết thúc',
  chooseLanguage: 'Chọn ngôn ngữ',
  en: 'Tiếng Anh',
  vn: 'Tiếng Việt',
  cn: 'Tiếng Trung giản thể',
  tw: 'truyền thống Trung Quốc',
  copy: 'sao chép',
  tips: 'dấu',
  scanQrcode: 'Quét Qrcode hoặc nhấp để sao chép địa chỉ',
  screenshotAndScript: 'Để tìm số theo dõi, vui lòng cung cấp ảnh chụp màn hình và mã tái bút',
  orderInfo: 'Thông tin đặt hàng',
  address: 'Địa chỉ',
  scripts: 'tái bút',
  qrcode: 'Quét mã',
  ipBlock: 'Bạn đã bị chặn, vui lòng liên hệ với cấp trên của bạn',
  invalidName: 'Không xác thực tên thật',
  paid: 'thanh toán thành công',
  channelMaintain: 'Kênh đang được bảo trì, vui lòng liên hệ bộ phận chăm sóc khách hàng',
  id_number: 'số CMND',
  phone: 'Số điện thoại',
  fixWrong: 'vui lòng sửa lỗi',
  formatWrong: 'không chính xác',
  mobilePlaceholder: 'điền số điện thoại di động của bạn (e.g. 254123456789)',
  loading: 'Đang xử lý...',
  recreateOrder: 'Kênh hiện không khả dụng. Vui lòng tạo lại đơn hàng',
  orderDetail: 'Chi tiết đơn hàng',
  paymentWarning: 'Vui lòng thanh toán theo thông tin hiển thị bên dưới',
  alipayAccount: 'Tài khoản Alipay',
  alipaySurname: 'Họ Alipay',
  alipayName: 'Tên Alipay',
  alipayRealName: 'Tên thật Alipay',
  paymentFlow: 'Quy trình thanh toán',
  pleasePayWithin: 'Vui lòng hoàn tất thanh toán trong',
  minute: 'phút',
  second: 'giây',
  countdownSuffix: ', quá thời hạn sẽ không được ghi có',
  orderExpired: 'Đơn hàng đã hết hạn',
  warmReminder: 'Nhắc nhở',
  copied: 'Đã sao chép',
  uploadProof: 'Tải lên bằng chứng thanh toán',
  selectImage: 'Nhấn để chọn ảnh',
  submitProof: 'Gửi bằng chứng',
  uploading: 'Đang tải lên...',
  uploadSuccess: 'Tải lên thành công',
  uploadFailed: 'Tải lên thất bại, vui lòng thử lại'
});
// CONCATENATED MODULE: ./src/models/models/Deposit.js


/* harmony default export */ var models_Deposit = ({
  info: function info(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/info', {
      params: params
    });
  },
  create: function create(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/create', {
      params: params
    });
  },
  info1: function info1(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/info1', {
      params: params
    });
  },
  create1: function create1(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/create1', {
      params: params
    });
  },
  c2c: function c2c(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/c2c', {
      params: params
    });
  },
  ip: function ip() {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/ip');
  },
  qrcode: function qrcode(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/qrcode', { params: params });
  },
  resource: function resource(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/resource', { params: params });
  },
  order: function order(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/order', { params: params });
  },
  uploadProof: function uploadProof(formData) {
    return vue_esm["a" /* default */].http.post(vue_esm["a" /* default */].prototype.serverUrl + 'pay/upload', formData);
  }
});
// CONCATENATED MODULE: ./src/models/index.js




vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var serverUrl = '/api/';
if (window.location.host === 'localhost:8080') {
  serverUrl = 'https://www.cnypay.today/api/';
}

var models = {
  Deposit: models_Deposit
};
/* harmony default export */ var src_models = ({
  install: function install(Vue) {
    Vue.prototype.$models = models;
    Vue.models = models;
    Vue.prototype.serverUrl = serverUrl;
  },

  $models: models
});

var $models = models;
// CONCATENATED MODULE: ./src/locales/index.js









vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
vue_esm["a" /* default */].use(src_models);

var localDefault = 'en';

var messages = {
  en: extends_default()({}, en),
  cn: extends_default()({}, zh_CN),
  tw: extends_default()({}, zh_TW),
  vn: extends_default()({}, vn)
};
var locale = localStorage.getItem('lang') || localDefault;

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: locale,
  messages: messages,
  fallbackLocale: localDefault,
  silentFallbackWarn: true
});

/* harmony default export */ var locales = (i18n);
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/main.js




























vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  component: src_components_Deposit
}, {
  path: '/deposit1',
  component: src_components_Deposit1
}, {
  path: '/deposit2',
  component: src_components_Deposit2
}, {
  path: '/deposit3',
  component: src_components_Deposit3
}, {
  path: '/alipay',
  component: src_components_Alipay
}, {
  path: '/bankcard',
  component: src_components_Bankcard
}, {
  path: '/usdt1',
  component: src_components_Usdt1
}, {
  path: '/usdt2',
  component: src_components_Usdt2
}, {
  path: '/usdt3',
  component: src_components_Usdt3
}, {
  path: '/usdt4',
  component: src_components_Usdt4
}, {
  path: '/usdt5',
  component: src_components_Usdt5
}, {
  path: '/qrcode',
  name: 'deposit-qrcode',
  component: src_components_Qrcode
}, {
  path: '/finished',
  name: 'finished',
  component: src_components_Finished
}, {
  path: '/error',
  name: 'error',
  component: src_components_Error
}, {
  path: '/c2c',
  name: 'c2c',
  component: src_components_C2C
}, {
  path: '/loading',
  name: 'loading',
  component: src_components_Loading
}, {
  path: '/order',
  name: 'order',
  component: src_components_Order
}];

var mode = void 0;
if (window.location.hash === '') {
  mode = 'history';
} else {
  mode = 'hash';
}

var main_router = new vue_router_esm["a" /* default */]({
  routes: routes,
  mode: mode
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

axios_default.a.defaults.withCredentials = true;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: main_router,
  i18n: locales,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "P1p9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAZCAYAAAA2VdDGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVkSURBVHgB7VpLTBtHGJ712sQ8bNPUSKgXHiZSSxWFBlzlwiOVIJdCLlWkVg1ppaYVEj0EKaAiyiM9oKhCTdVDD+2t6YEDFEovNDkAoWoaqQ0Vkk3Fw0aAoWCBH9SAX9v/X+9sxotNDAiCkv2k0c7Mzv/Pznz7/fMvhhAVzwKcVFScYHBra2tlc5uejWg06lxYWCgSBEEl7QSCW15etv658e/Gyz9/K3TZHgpI2Ozs7BmiquxEIY4ovu+OWFjCUlGYlqg4UiAJi4uLVpdeM1zzoD/bE9qR792yP8RL3uevvnlvbm6uGuozaJLMl4aoOEpwKysrZatZabuIokDCvph6lFdQUHDPbref6ezsTMqJGiuPDhj6ykBRvyYjikX7axcIKGze4XBUWyyWhApTksV5vd6X9Hp9Fc/zpp2dnb8zMzMfkz2kqSIhOMj0rHspKhFYwgoLC2c4jovbd61iAovBYLgPg/KwIyMjg4RCoW90Ot0NiL1RpbGK3aBn1H6JQrBn2NTUVA34mmb3nKMTALSQmUxTolhsbW3dBOK+gmqU7K0yUZmgxsubm5uj2dnZDvICqRL3Ec+oVENfMiQLiaKyurq6uMnJSWsiosRBWu01n8/nhfAYoX2RSISDUBlHBKhQA2MvQ//bRqPRCzY3QZVRpT9qR33gVdnPtg+DVOdItB6lvfKqXFMgENAAUV8ehigEq7CxsTFrRUWFG9qCSBZmIJWVlWnJjEFxp4PB4KVwOByl3wNx8gRI40hWVtYbUp8JFnQFigf7cTwdBz4E6cppNLHkR4hB3kCs0z46l1hhbJn54/rYNvpn58c6AvvRF72/H//s81F7bMMRcmHctXQooigGXbOkueBcYGJi4hTww0GJkVVVVUWGh4cXy8vL/fAgBqWhx+N5lJub2wzVEIlJUkhPT8fwKK4F67G1CLqmpiZLY2Pjp+vr6/bS0tLvIUkJklj4FMcybgVFn9ym/qh/aT4O23Re5RipXx5H4sOvOIdkI9tJY+laOOW6FM8qz6FcC/SjP769vd3S2tp6F8h65Zb9D3JQnDPlkJ/OX/qnvr7+vZGREQ/wE3sJpfu8yWQywo3rJSUlt1lDUNRST0/Pu93d3Ta/3x+UHpzk5OQQ+DsX9UEXwEPRQ0GVRsFnAM6wMLtgvJrNZvElRnvqh/EnA/sQdB5oow3H+lLMTxL45pRzu91ugd6jPlnfyZ4J26ggsCdk91mMISK9ra3tdSg/3J57fCDCKFGN1z68Cnw4YM99RBIJJYuTNvl0c3NzcUNDwwegMCPE4MWOjo7vent7nXDPDyX8lLnQD5+fn887nU4B3ogITBghBwPd4OO2PagPHKuDYoAc4GxLS8vd/RLGEjU0NOQoKiryz8zMyAKRHwbPLSgYJ7Kg4JUHeQdB3v9BfZM8CYEqkoMrLi7W2Ww2I4TEsxgSUyWMEtV0/ZP3+/r65qGLKkpO0HhaAQUgERGYLAjS34a6HxKKAFyxjopSiUoBq6urUVBWeHR01AeZ8HhL7TvVWi1vGHUvJbVhFTUwMDAPHHiBA9zzuEyaV9hh3MawFZZKSGmgYm8AUXjBFzsEAvACYb/tRRgl6sZHH18dHBx0QpcPOEgYxXii4iiAG40veRgI80F6P/5Z3ZVdhLFE9ff3O0ks9MlnlIrjBeYEp6CYIR94a3t7e6nL9rv4W9b5+z8K8+vuqdraWivcz5HGqb+CPGMgYfgpY4ak4yIS9vX0XyJRdXV1ZeQJUU/NPNUweDzAkBiBpMMDGfYD/cLqLzVVF++4XK4V+I7FTyI10z5hoCExG4oZigmyvjSyj2859cfH4wX9FzQ8m2gSoirqecT/jo1qmEggfpgAAAAASUVORK5CYII="

/***/ }),

/***/ "PZ4B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title3.2e340d8.png";

/***/ }),

/***/ "Pm1e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/005.7350845.png";

/***/ }),

/***/ "Qhem":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01.dbf0b36.png";

/***/ }),

/***/ "QxhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rg/T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-4.5795ca6.png";

/***/ }),

/***/ "RlBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0004.68e379f.png";

/***/ }),

/***/ "USOW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/03.01b5fbe.png";

/***/ }),

/***/ "WSOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X3S4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XBIu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-1.ef65b5f.png";

/***/ }),

/***/ "XHW0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XcBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XeZn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/WX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/03.01b5fbe.png";

/***/ }),

/***/ "YAFA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAZCAYAAADZl7v4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUSSURBVHgB7VldTCNVFD532vLXltKC/AVcQxCRZIGIURKzCSbuhid1syG+En3gxcQHfZGgodVswkZc3/RF2U3WFxIxLiEhiw8kPuwaJWHVLUQgoJRiXCkU2tp2247ntHPJ7WSmpXUX2GS+5HbuPffcc8/Md8+9Z6YABh4LsAJ12d7e3lPUqKqq2sBLCgycKrC+vj5zLBb76PrGPTkQj+5ubm6+gHIJDJwaUCRZQqHQZbf3jmz65jP5ue+/lndikT2DrONDvofMenp6zEiSe/zP3973LN1JC+8G78P5H751VNRW30KyngeDrEcOlqfPHA6HRz/549dhTpKILscTMHfuYjDy986F5ubmn8E4sx4ZdCMBzyQTRZIeSQQjso4PTEdGJHnE7S4XjMh6KOBcyFqdWhFQEEkEI7L+F9KBgRn1xUQicS2ZTF6Px+NvDgwMmGRZZqJS1oD9/X3PVZ/3yCSJMCKrcNBrz+zs7NXS0tK3RTmS9THKRrGapPbhyleyu6JJImhElgmUF+UcBY5QVy8oOIJdptLPZbsQv/TGS/gxoIciIhKJXBodHZXyzUNRMzk5eUlNEqGkpGTE7/e/AgpHfFLzwcGB+9PNe8PFkiSCR5YNTNOMMe09V5IglUrllKt1qE1Qy6itZ68Q23p9uWxwf2ibslgs5/B+z5AMI+IGv/dc94rjus1m81mtuYLB4Bh+AfoAqw/M+MOamposaKj1TIUdHgZea2yBf+8HvvsrGPwFnUihQ7JyQ4zq/MplitNZOuo6h56M29Dq1xunNV5Plq8djUbNbW1tL2MkAJ43/pWVlbtYT3KftOzjmSTV1NTYa2trNYnCHS7c2toqra6uAhEl+3w+qK+vf29tba3sy57zr761MAfF4sNnX4Q3JOcXSP641WoN4XtYUqUi22w2pjgCdrtdxmimK+A1KwulPlqppEfAccDreiAdWslkS0M/PTfJeB+/Kn4wUYf7BpmdRyYfRX+4TaXf4na7f+rv739pZmbmtsfjWUFZXOkXfef6BNPExMTvg4ODr2vdy9TU1ByRBMIAIsyGpQb3xfFb8d2iyOIkdXd3X8EVtotkxSorK5Ner1dTH1cLQ0fkjo4OUHTSD4TaBGGcWp5uC6bSbbJHDVzJMm49adtCP58T+M3zMYoeE/txLpnmUdqH/YocFJ8Zb0PmPC7DYsF7TmBSRiTFlTEgjhHmpb3TvrS09E57e/swdwrPuYPFxcXLmGh8heQGUJQ4vAFMJiwLCwtEVnUxZKlIIuNhUDIW4aGq39tkHXP59MR3Dga57Wjp5JPr2dLySbQl4cNl8/PzJE9Cbr8JEi7mUtzRnCMjIx29vb1n8UyyjY2NzU1PT/uwfxdLhPTVk5c4HA4rHmIFkSWSVF5eHujq6gqjswkwcBRIDQ0NZdvb2xVYLyUBbrEx3CojQ0NDUcwe01mImigKZQuGpxVTxur19fW8ZHGSMHSvuFyunUAgQCvAIKkwSEIhEDlZEan+gkD77QO8hjBzCTQ2Nr57ocR5ExMMTesiSU6nM9DZ2WmQVByIGHpu/Fyjeta2mevruQUL5esurW1QJAmb/EwySDohEFkuLE9vbW3dvIb/7tIfh27vbXl5eflzlLdgcUAmazRwkqBsENNNF55ZrRsbGzd+/Me/j6njGHa14JlUCRmSGBg4cTBOFmQi6BksT2KpAiOSTh3SZNXV1Vmx7sB0soK++oKBU4v0Sx0YW92x4z9ydOn5zeeuBwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "YMMG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YYoF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0004.68e379f.png";

/***/ }),

/***/ "aNUl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0006.1b023aa.png";

/***/ }),

/***/ "cAOh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cVoO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0001.52dd0a4.png";

/***/ }),

/***/ "cnJP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04.46c23a7.png";

/***/ }),

/***/ "d20T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone3.950fb07.png";

/***/ }),

/***/ "d3ut":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAZCAYAAADZl7v4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUSSURBVHgB7VldTCNVFD532vLXltKC/AVcQxCRZIGIURKzCSbuhid1syG+En3gxcQHfZGgodVswkZc3/RF2U3WFxIxLiEhiw8kPuwaJWHVLUQgoJRiXCkU2tp2247ntHPJ7WSmpXUX2GS+5HbuPffcc8/Md8+9Z6YABh4LsAJ12d7e3lPUqKqq2sBLCgycKrC+vj5zLBb76PrGPTkQj+5ubm6+gHIJDJwaUCRZQqHQZbf3jmz65jP5ue+/lndikT2DrONDvofMenp6zEiSe/zP3973LN1JC+8G78P5H751VNRW30KyngeDrEcOlqfPHA6HRz/549dhTpKILscTMHfuYjDy986F5ubmn8E4sx4ZdCMBzyQTRZIeSQQjso4PTEdGJHnE7S4XjMh6KOBcyFqdWhFQEEkEI7L+F9KBgRn1xUQicS2ZTF6Px+NvDgwMmGRZZqJS1oD9/X3PVZ/3yCSJMCKrcNBrz+zs7NXS0tK3RTmS9THKRrGapPbhyleyu6JJImhElgmUF+UcBY5QVy8oOIJdptLPZbsQv/TGS/gxoIciIhKJXBodHZXyzUNRMzk5eUlNEqGkpGTE7/e/AgpHfFLzwcGB+9PNe8PFkiSCR5YNTNOMMe09V5IglUrllKt1qE1Qy6itZ68Q23p9uWxwf2ibslgs5/B+z5AMI+IGv/dc94rjus1m81mtuYLB4Bh+AfoAqw/M+MOamposaKj1TIUdHgZea2yBf+8HvvsrGPwFnUihQ7JyQ4zq/MplitNZOuo6h56M29Dq1xunNV5Plq8djUbNbW1tL2MkAJ43/pWVlbtYT3KftOzjmSTV1NTYa2trNYnCHS7c2toqra6uAhEl+3w+qK+vf29tba3sy57zr761MAfF4sNnX4Q3JOcXSP641WoN4XtYUqUi22w2pjgCdrtdxmimK+A1KwulPlqppEfAccDreiAdWslkS0M/PTfJeB+/Kn4wUYf7BpmdRyYfRX+4TaXf4na7f+rv739pZmbmtsfjWUFZXOkXfef6BNPExMTvg4ODr2vdy9TU1ByRBMIAIsyGpQb3xfFb8d2iyOIkdXd3X8EVtotkxSorK5Ner1dTH1cLQ0fkjo4OUHTSD4TaBGGcWp5uC6bSbbJHDVzJMm49adtCP58T+M3zMYoeE/txLpnmUdqH/YocFJ8Zb0PmPC7DYsF7TmBSRiTFlTEgjhHmpb3TvrS09E57e/swdwrPuYPFxcXLmGh8heQGUJQ4vAFMJiwLCwtEVnUxZKlIIuNhUDIW4aGq39tkHXP59MR3Dga57Wjp5JPr2dLySbQl4cNl8/PzJE9Cbr8JEi7mUtzRnCMjIx29vb1n8UyyjY2NzU1PT/uwfxdLhPTVk5c4HA4rHmIFkSWSVF5eHujq6gqjswkwcBRIDQ0NZdvb2xVYLyUBbrEx3CojQ0NDUcwe01mImigKZQuGpxVTxur19fW8ZHGSMHSvuFyunUAgQCvAIKkwSEIhEDlZEan+gkD77QO8hjBzCTQ2Nr57ocR5ExMMTesiSU6nM9DZ2WmQVByIGHpu/Fyjeta2mevruQUL5esurW1QJAmb/EwySDohEFkuLE9vbW3dvIb/7tIfh27vbXl5eflzlLdgcUAmazRwkqBsENNNF55ZrRsbGzd+/Me/j6njGHa14JlUCRmSGBg4cTBOFmQi6BksT2KpAiOSTh3SZNXV1Vmx7sB0soK++oKBU4v0Sx0YW92x4z9ydOn5zeeuBwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "e5wT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/002.9b69576.png";

/***/ }),

/***/ "ecYn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "esPN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.c244bdd.png";

/***/ }),

/***/ "fFUN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fKba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fzG1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4bv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tip-2.54519a1.png";

/***/ }),

/***/ "g5h6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7jX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TITLE.ee3cdc2.png";

/***/ }),

/***/ "hUmw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i20+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0006.1b023aa.png";

/***/ }),

/***/ "izpx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lLR9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/002.9b69576.png";

/***/ }),

/***/ "lQZp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("g5h6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "niMn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone1.c7b9ba7.png";

/***/ }),

/***/ "oXsw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q29H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "r/47":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("v0z+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rrTR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0005.c6e5515.png";

/***/ }),

/***/ "t1QK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0003.cf5315c.png";

/***/ }),

/***/ "tbht":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/02.6f7414b.png";

/***/ }),

/***/ "u7uk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v0z+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v7FE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/004.854af58.png";

/***/ }),

/***/ "vOB+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iphone2.ec33b50.png";

/***/ }),

/***/ "w2p9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05.d5a342b.png";

/***/ }),

/***/ "xCNR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0001.52dd0a4.png";

/***/ }),

/***/ "yHrf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0007.7a637ca.png";

/***/ }),

/***/ "yYq8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zOHV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0002.f6fe120.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.25eba5841729fc7c42b2.js